var items = {
  "block.minecraft.acacia_button": "Wattle Knap",
  "block.minecraft.acacia_door": "Wattle Door",
  "block.minecraft.acacia_fence": "Wattle Edder",
  "block.minecraft.acacia_fence_gate": "Wattle Edder Gate",
  "block.minecraft.acacia_hanging_sign": "Wattle Hanging Token",
  "block.minecraft.acacia_leaves": "Wattle Leaves",
  "block.minecraft.acacia_log": "Wattle Log",
  "block.minecraft.acacia_planks": "Wattle Boards",
  "block.minecraft.acacia_pressure_plate": "Wattle Thrutch Tile",
  "block.minecraft.acacia_sapling": "Wattle Sapling",
  "block.minecraft.acacia_shelf": "Wattle Shelf",
  "block.minecraft.acacia_sign": "Wattle Token",
  "block.minecraft.acacia_slab": "Wattle Halfclot",
  "block.minecraft.acacia_stairs": "Wattle Stairs",
  "block.minecraft.acacia_trapdoor": "Wattle Trapdoor",
  "block.minecraft.acacia_wall_hanging_sign": "Wattle Wall Hanging Token",
  "block.minecraft.acacia_wall_sign": "Wattle Wall Token",
  "block.minecraft.acacia_wood": "Wattle Wood",
  "block.minecraft.activator_rail": "Astirrer Ironroad",
  "block.minecraft.air": "Lift",
  "block.minecraft.allium": "Entleek",
  "block.minecraft.amethyst_block": "Drunklack Clot",
  "block.minecraft.amethyst_cluster": "Drunklack Cluster",
  "block.minecraft.ancient_debris": "Fern Lave",
  "block.minecraft.andesite": "Andestone",
  "block.minecraft.andesite_slab": "Andestone Halfclot",
  "block.minecraft.andesite_stairs": "Andestone Stairs",
  "block.minecraft.andesite_wall": "Andestone Wall",
  "block.minecraft.anvil": "Anvil",
  "block.minecraft.attached_melon_stem": "Linked Entapple Stem",
  "block.minecraft.attached_pumpkin_stem": "Linked Harvestovet Stem",
  "block.minecraft.azalea": "Drywort",
  "block.minecraft.azalea_leaves": "Drywort Leaves",
  "block.minecraft.azure_bluet": "Hewnling",
  "block.minecraft.bamboo": "Treereed",
  "block.minecraft.bamboo_block": "Treereed Clot",
  "block.minecraft.bamboo_button": "Treereed Knap",
  "block.minecraft.bamboo_door": "Treereed Door",
  "block.minecraft.bamboo_fence": "Treereed Edder",
  "block.minecraft.bamboo_fence_gate": "Treereed Edder Gate",
  "block.minecraft.bamboo_hanging_sign": "Treereed Hanging Token",
  "block.minecraft.bamboo_mosaic": "Woven Treereed",
  "block.minecraft.bamboo_mosaic_slab": "Woven Treereed Halfclot",
  "block.minecraft.bamboo_mosaic_stairs": "Woven Treereed Stairs",
  "block.minecraft.bamboo_planks": "Treereed Boards",
  "block.minecraft.bamboo_pressure_plate": "Treereed Thrutch Tile",
  "block.minecraft.bamboo_sapling": "Treereed Shoot",
  "block.minecraft.bamboo_shelf": "Treereed Shelf",
  "block.minecraft.bamboo_sign": "Treereed Token",
  "block.minecraft.bamboo_slab": "Treereed Halfclot",
  "block.minecraft.bamboo_stairs": "Treereed Stairs",
  "block.minecraft.bamboo_trapdoor": "Treereed Trapdoor",
  "block.minecraft.bamboo_wall_hanging_sign": "Treereed Wall Hanging Token",
  "block.minecraft.bamboo_wall_sign": "Treereed Wall Token",
  "block.minecraft.banner.base.black": "Fully Black Field",
  "block.minecraft.banner.base.blue": "Fully Bloe Field",
  "block.minecraft.banner.base.brown": "Fully Brown Field",
  "block.minecraft.banner.base.cyan": "Fully Teal Field",
  "block.minecraft.banner.base.gray": "Fully Gray Field",
  "block.minecraft.banner.base.green": "Fully Green Field",
  "block.minecraft.banner.base.light_blue": "Fully Light Bloe Field",
  "block.minecraft.banner.base.light_gray": "Fully Light Gray Field",
  "block.minecraft.banner.base.lime": "Fully Light Green Field",
  "block.minecraft.banner.base.magenta": "Fully Light Purple Field",
  "block.minecraft.banner.base.orange": "Fully Yellowred Field",
  "block.minecraft.banner.base.pink": "Fully Bleak Red Field",
  "block.minecraft.banner.base.purple": "Fully Purple Field",
  "block.minecraft.banner.base.red": "Fully Red Field",
  "block.minecraft.banner.base.white": "Fully White Field",
  "block.minecraft.banner.base.yellow": "Fully Yellow Field",
  "block.minecraft.banner.border.black": "Black Frame",
  "block.minecraft.banner.border.blue": "Bloe Frame",
  "block.minecraft.banner.border.brown": "Brown Frame",
  "block.minecraft.banner.border.cyan": "Teal Frame",
  "block.minecraft.banner.border.gray": "Gray Frame",
  "block.minecraft.banner.border.green": "Green Frame",
  "block.minecraft.banner.border.light_blue": "Light Bloe Frame",
  "block.minecraft.banner.border.light_gray": "Light Gray Frame",
  "block.minecraft.banner.border.lime": "Light Green Frame",
  "block.minecraft.banner.border.magenta": "Light Purple Frame",
  "block.minecraft.banner.border.orange": "Yellowred Frame",
  "block.minecraft.banner.border.pink": "Bleak Red Frame",
  "block.minecraft.banner.border.purple": "Purple Frame",
  "block.minecraft.banner.border.red": "Red Frame",
  "block.minecraft.banner.border.white": "White Frame",
  "block.minecraft.banner.border.yellow": "Yellow Frame",
  "block.minecraft.banner.bricks.black": "Black Field Stonewrought",
  "block.minecraft.banner.bricks.blue": "Bloe Field Stonewrought",
  "block.minecraft.banner.bricks.brown": "Brown Field Stonewrought",
  "block.minecraft.banner.bricks.cyan": "Teal Field Stonewrought",
  "block.minecraft.banner.bricks.gray": "Gray Field Stonewrought",
  "block.minecraft.banner.bricks.green": "Green Field Stonewrought",
  "block.minecraft.banner.bricks.light_blue": "Light Bloe Field Stonewrought",
  "block.minecraft.banner.bricks.light_gray": "Light Gray Field Stonewrought",
  "block.minecraft.banner.bricks.lime": "Light Green Field Stonewrought",
  "block.minecraft.banner.bricks.magenta": "Light Purple Field Stonewrought",
  "block.minecraft.banner.bricks.orange": "Yellowred Field Stonewrought",
  "block.minecraft.banner.bricks.pink": "Bleak Red Field Stonewrought",
  "block.minecraft.banner.bricks.purple": "Purple Field Stonewrought",
  "block.minecraft.banner.bricks.red": "Red Field Stonewrought",
  "block.minecraft.banner.bricks.white": "White Field Stonewrought",
  "block.minecraft.banner.bricks.yellow": "Yellow Field Stonewrought",
  "block.minecraft.banner.circle.black": "Black Trendle",
  "block.minecraft.banner.circle.blue": "Bloe Trendle",
  "block.minecraft.banner.circle.brown": "Brown Trendle",
  "block.minecraft.banner.circle.cyan": "Teal Trendle",
  "block.minecraft.banner.circle.gray": "Gray Trendle",
  "block.minecraft.banner.circle.green": "Green Trendle",
  "block.minecraft.banner.circle.light_blue": "Light Bloe Trendle",
  "block.minecraft.banner.circle.light_gray": "Light Gray Trendle",
  "block.minecraft.banner.circle.lime": "Light Green Trendle",
  "block.minecraft.banner.circle.magenta": "Light Purple Trendle",
  "block.minecraft.banner.circle.orange": "Yellowred Trendle",
  "block.minecraft.banner.circle.pink": "Bleak Red Trendle",
  "block.minecraft.banner.circle.purple": "Purple Trendle",
  "block.minecraft.banner.circle.red": "Red Trendle",
  "block.minecraft.banner.circle.white": "White Trendle",
  "block.minecraft.banner.circle.yellow": "Yellow Trendle",
  "block.minecraft.banner.creeper.black": "Black Creeper Shape",
  "block.minecraft.banner.creeper.blue": "Bloe Creeper Shape",
  "block.minecraft.banner.creeper.brown": "Brown Creeper Shape",
  "block.minecraft.banner.creeper.cyan": "Teal Creeper Shape",
  "block.minecraft.banner.creeper.gray": "Gray Creeper Shape",
  "block.minecraft.banner.creeper.green": "Green Creeper Shape",
  "block.minecraft.banner.creeper.light_blue": "Light Bloe Creeper Shape",
  "block.minecraft.banner.creeper.light_gray": "Light Gray Creeper Shape",
  "block.minecraft.banner.creeper.lime": "Light Green Creeper Shape",
  "block.minecraft.banner.creeper.magenta": "Light Purple Creeper Shape",
  "block.minecraft.banner.creeper.orange": "Yellowred Creeper Shape",
  "block.minecraft.banner.creeper.pink": "Bleak Red Creeper Shape",
  "block.minecraft.banner.creeper.purple": "Purple Creeper Shape",
  "block.minecraft.banner.creeper.red": "Red Creeper Shape",
  "block.minecraft.banner.creeper.white": "White Creeper Shape",
  "block.minecraft.banner.creeper.yellow": "Yellow Creeper Shape",
  "block.minecraft.banner.cross.black": "Black Leaning Cross",
  "block.minecraft.banner.cross.blue": "Bloe Leaning Cross",
  "block.minecraft.banner.cross.brown": "Brown Leaning Cross",
  "block.minecraft.banner.cross.cyan": "Teal Leaning Cross",
  "block.minecraft.banner.cross.gray": "Gray Leaning Cross",
  "block.minecraft.banner.cross.green": "Green Leaning Cross",
  "block.minecraft.banner.cross.light_blue": "Light Bloe Leaning Cross",
  "block.minecraft.banner.cross.light_gray": "Light Gray Leaning Cross",
  "block.minecraft.banner.cross.lime": "Light Green Leaning Cross",
  "block.minecraft.banner.cross.magenta": "Light Purple Leaning Cross",
  "block.minecraft.banner.cross.orange": "Yellowred Leaning Cross",
  "block.minecraft.banner.cross.pink": "Bleak Red Leaning Cross",
  "block.minecraft.banner.cross.purple": "Purple Leaning Cross",
  "block.minecraft.banner.cross.red": "Red Leaning Cross",
  "block.minecraft.banner.cross.white": "White Leaning Cross",
  "block.minecraft.banner.cross.yellow": "Yellow Leaning Cross",
  "block.minecraft.banner.curly_border.black": "Black Sawtoothed Frame",
  "block.minecraft.banner.curly_border.blue": "Bloe Sawtoothed Frame",
  "block.minecraft.banner.curly_border.brown": "Brown Sawtoothed Frame",
  "block.minecraft.banner.curly_border.cyan": "Teal Sawtoothed Frame",
  "block.minecraft.banner.curly_border.gray": "Gray Sawtoothed Frame",
  "block.minecraft.banner.curly_border.green": "Green Sawtoothed Frame",
  "block.minecraft.banner.curly_border.light_blue": "Light Bloe Sawtoothed Frame",
  "block.minecraft.banner.curly_border.light_gray": "Light Gray Sawtoothed Frame",
  "block.minecraft.banner.curly_border.lime": "Light Green Sawtoothed Frame",
  "block.minecraft.banner.curly_border.magenta": "Light Purple Sawtoothed Frame",
  "block.minecraft.banner.curly_border.orange": "Yellow Sawtoothed Frame",
  "block.minecraft.banner.curly_border.pink": "Bleak Red Sawtoothed Frame",
  "block.minecraft.banner.curly_border.purple": "Purple Sawtoothed Frame",
  "block.minecraft.banner.curly_border.red": "Red Sawtoothed Frame",
  "block.minecraft.banner.curly_border.white": "White Sawtoothed Frame",
  "block.minecraft.banner.curly_border.yellow": "Yellow Sawtoothed Frame",
  "block.minecraft.banner.diagonal_left.black": "Black Left Leaning Up",
  "block.minecraft.banner.diagonal_left.blue": "Bloe Left Leaning Up",
  "block.minecraft.banner.diagonal_left.brown": "Brown Left Leaning Up",
  "block.minecraft.banner.diagonal_left.cyan": "Teal Left Leaning Up",
  "block.minecraft.banner.diagonal_left.gray": "Gray Left Leaning Up",
  "block.minecraft.banner.diagonal_left.green": "Green Left Leaning Up",
  "block.minecraft.banner.diagonal_left.light_blue": "Light Bloe Left Leaning Up",
  "block.minecraft.banner.diagonal_left.light_gray": "Light Gray Left Leaning Up",
  "block.minecraft.banner.diagonal_left.lime": "Light Green Left Leaning Up",
  "block.minecraft.banner.diagonal_left.magenta": "Light Purple Left Leaning Up",
  "block.minecraft.banner.diagonal_left.orange": "Yellowred Left Leaning Up",
  "block.minecraft.banner.diagonal_left.pink": "Bleak Red Left Leaning Up",
  "block.minecraft.banner.diagonal_left.purple": "Purple Left Leaning Up",
  "block.minecraft.banner.diagonal_left.red": "Red Left Leaning Up",
  "block.minecraft.banner.diagonal_left.white": "White Left Leaning Up",
  "block.minecraft.banner.diagonal_left.yellow": "Yellow Left Leaning Up",
  "block.minecraft.banner.diagonal_right.black": "Black Right Leaning Up",
  "block.minecraft.banner.diagonal_right.blue": "Bloe Right Leaning Up",
  "block.minecraft.banner.diagonal_right.brown": "Brown Right Leaning Up",
  "block.minecraft.banner.diagonal_right.cyan": "Teal Right Leaning Up",
  "block.minecraft.banner.diagonal_right.gray": "Gray Right Leaning Up",
  "block.minecraft.banner.diagonal_right.green": "Green Right Leaning Up",
  "block.minecraft.banner.diagonal_right.light_blue": "Light Bloe Right Leaning Up",
  "block.minecraft.banner.diagonal_right.light_gray": "Light Gray Right Leaning Up",
  "block.minecraft.banner.diagonal_right.lime": "Light Green Right Leaning Up",
  "block.minecraft.banner.diagonal_right.magenta": "Light Purple Right Leaning Up",
  "block.minecraft.banner.diagonal_right.orange": "Yellowred Right Leaning Up",
  "block.minecraft.banner.diagonal_right.pink": "Bleak Red Right Leaning Up",
  "block.minecraft.banner.diagonal_right.purple": "Purple Right Leaning Up",
  "block.minecraft.banner.diagonal_right.red": "Red Right Leaning Up",
  "block.minecraft.banner.diagonal_right.white": "White Right Leaning Up",
  "block.minecraft.banner.diagonal_right.yellow": "Yellow Right Leaning Up",
  "block.minecraft.banner.diagonal_up_left.black": "Black Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.blue": "Bloe Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.brown": "Brown Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.cyan": "Teal Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.gray": "Gray Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.green": "Green Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Light Bloe Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Light Gray Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.lime": "Light Green Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.magenta": "Light Purple Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.orange": "Yellowred Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.pink": "Bleak Red Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.purple": "Purple Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.red": "Red Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.white": "White Left Leaning Down",
  "block.minecraft.banner.diagonal_up_left.yellow": "Yellow Left Leaning Down",
  "block.minecraft.banner.diagonal_up_right.black": "Black Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.blue": "Bloe Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.brown": "Brown Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.cyan": "Teal Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.gray": "Gray Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.green": "Green Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Light Bloe Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Light Gray Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.lime": "Light Green Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.magenta": "Light Purple Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.orange": "Yellowred Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.pink": "Bleak Red Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.purple": "Purple Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.red": "Red Right Slanted Down",
  "block.minecraft.banner.diagonal_up_right.white": "White Right Leaning Down",
  "block.minecraft.banner.diagonal_up_right.yellow": "Yellow Right Leaning Down",
  "block.minecraft.banner.flow.black": "Black Flow",
  "block.minecraft.banner.flow.blue": "Bloe Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Teal Flow",
  "block.minecraft.banner.flow.gray": "Gray Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Bloe Flow",
  "block.minecraft.banner.flow.light_gray": "Light Gray Flow",
  "block.minecraft.banner.flow.lime": "Light Green Flow",
  "block.minecraft.banner.flow.magenta": "Light Purple Flow",
  "block.minecraft.banner.flow.orange": "Yellowred Flow",
  "block.minecraft.banner.flow.pink": "Bleak Red Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "Black Bloom Shape",
  "block.minecraft.banner.flower.blue": "Bloe Bloom Shape",
  "block.minecraft.banner.flower.brown": "Brown Bloom Shape",
  "block.minecraft.banner.flower.cyan": "Teal Bloom Shape",
  "block.minecraft.banner.flower.gray": "Gray Bloom Shape",
  "block.minecraft.banner.flower.green": "Green Bloom Shape",
  "block.minecraft.banner.flower.light_blue": "Light Bloe Bloom Shape",
  "block.minecraft.banner.flower.light_gray": "Light Gray Bloom Shape",
  "block.minecraft.banner.flower.lime": "Light Green Bloom Shape",
  "block.minecraft.banner.flower.magenta": "Light Purple Bloom Shape",
  "block.minecraft.banner.flower.orange": "Yellowred Bloom Shape",
  "block.minecraft.banner.flower.pink": "Bleak Red Bloom Shape",
  "block.minecraft.banner.flower.purple": "Purple Bloom Shape",
  "block.minecraft.banner.flower.red": "Red Bloom Shape",
  "block.minecraft.banner.flower.white": "White Bloom Shape",
  "block.minecraft.banner.flower.yellow": "Yellow Bloom Shape",
  "block.minecraft.banner.globe.black": "Black Thother",
  "block.minecraft.banner.globe.blue": "Bloe Thother",
  "block.minecraft.banner.globe.brown": "Brown Thother",
  "block.minecraft.banner.globe.cyan": "Teal Thother",
  "block.minecraft.banner.globe.gray": "Gray Thother",
  "block.minecraft.banner.globe.green": "Green Thother",
  "block.minecraft.banner.globe.light_blue": "Light Bloe Thother",
  "block.minecraft.banner.globe.light_gray": "Light Gray Thother",
  "block.minecraft.banner.globe.lime": "Light Green Thother",
  "block.minecraft.banner.globe.magenta": "Light Purple Thother",
  "block.minecraft.banner.globe.orange": "Yellowred Thother",
  "block.minecraft.banner.globe.pink": "Bleak Red Thother",
  "block.minecraft.banner.globe.purple": "Purple Thother",
  "block.minecraft.banner.globe.red": "Red Thother",
  "block.minecraft.banner.globe.white": "White Thother",
  "block.minecraft.banner.globe.yellow": "Yellow Thother",
  "block.minecraft.banner.gradient.black": "Black Dimming",
  "block.minecraft.banner.gradient.blue": "Bloe Dimming",
  "block.minecraft.banner.gradient.brown": "Brown Dimming",
  "block.minecraft.banner.gradient.cyan": "Teal Dimming",
  "block.minecraft.banner.gradient.gray": "Gray Dimming",
  "block.minecraft.banner.gradient.green": "Green Dimming",
  "block.minecraft.banner.gradient.light_blue": "Light Bloe Dimming",
  "block.minecraft.banner.gradient.light_gray": "Light Gray Dimming",
  "block.minecraft.banner.gradient.lime": "Light Green Dimming",
  "block.minecraft.banner.gradient.magenta": "Light Purple Dimming",
  "block.minecraft.banner.gradient.orange": "Yellowred Dimming",
  "block.minecraft.banner.gradient.pink": "Bleak Red Dimming",
  "block.minecraft.banner.gradient.purple": "Purple Dimming",
  "block.minecraft.banner.gradient.red": "Red Dimming",
  "block.minecraft.banner.gradient.white": "White Dimming",
  "block.minecraft.banner.gradient.yellow": "Yellow Dimming",
  "block.minecraft.banner.gradient_up.black": "Black Bottom Dimming",
  "block.minecraft.banner.gradient_up.blue": "Bloe Bottom Dimming",
  "block.minecraft.banner.gradient_up.brown": "Brown Bottom Dimming",
  "block.minecraft.banner.gradient_up.cyan": "Teal Bottom Dimming",
  "block.minecraft.banner.gradient_up.gray": "Gray Bottom Dimming",
  "block.minecraft.banner.gradient_up.green": "Green Bottom Dimming",
  "block.minecraft.banner.gradient_up.light_blue": "Light Bloe Bottom Dimming",
  "block.minecraft.banner.gradient_up.light_gray": "Light Gray Bottom Dimming",
  "block.minecraft.banner.gradient_up.lime": "Light Green Bottom Dimming",
  "block.minecraft.banner.gradient_up.magenta": "Light Purple Bottom Dimming",
  "block.minecraft.banner.gradient_up.orange": "Yellowred Bottom Dimming",
  "block.minecraft.banner.gradient_up.pink": "Bleak Red Bottom Dimming",
  "block.minecraft.banner.gradient_up.purple": "Purple Bottom Dimming",
  "block.minecraft.banner.gradient_up.red": "Red Bottom Dimming",
  "block.minecraft.banner.gradient_up.white": "White Bottom Dimming",
  "block.minecraft.banner.gradient_up.yellow": "Yellow Bottom Dimming",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Bloe Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Teal Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Bloe Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Light Green Guster",
  "block.minecraft.banner.guster.magenta": "Light Purple Guster",
  "block.minecraft.banner.guster.orange": "Yellowred Guster",
  "block.minecraft.banner.guster.pink": "Bleak Red Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "Black Top Half",
  "block.minecraft.banner.half_horizontal.blue": "Bloe Top Half",
  "block.minecraft.banner.half_horizontal.brown": "Brown Top Half",
  "block.minecraft.banner.half_horizontal.cyan": "Teal Top Half",
  "block.minecraft.banner.half_horizontal.gray": "Gray Top Half",
  "block.minecraft.banner.half_horizontal.green": "Green Top Half",
  "block.minecraft.banner.half_horizontal.light_blue": "Light Bloe Top Half",
  "block.minecraft.banner.half_horizontal.light_gray": "Light Gray Top Half",
  "block.minecraft.banner.half_horizontal.lime": "Light Green Top Half",
  "block.minecraft.banner.half_horizontal.magenta": "Light Purple Top Half",
  "block.minecraft.banner.half_horizontal.orange": "Yellowred Top Half",
  "block.minecraft.banner.half_horizontal.pink": "Bleak Red Top Half",
  "block.minecraft.banner.half_horizontal.purple": "Purple Top Half",
  "block.minecraft.banner.half_horizontal.red": "Red Top Half",
  "block.minecraft.banner.half_horizontal.white": "White Top Half",
  "block.minecraft.banner.half_horizontal.yellow": "Yellow Top Half",
  "block.minecraft.banner.half_horizontal_bottom.black": "Black Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Bloe Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brown Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Teal Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Gray Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.green": "Green Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Light Bloe Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Light Gray Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Light Green Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Light Purple Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Yellowred Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Bleak Red Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Purple Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.red": "Red Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.white": "White Bottom Half",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Yellow Bottom Half",
  "block.minecraft.banner.half_vertical.black": "Black Upright Half",
  "block.minecraft.banner.half_vertical.blue": "Bloe Upright Half",
  "block.minecraft.banner.half_vertical.brown": "Brown Upright Half",
  "block.minecraft.banner.half_vertical.cyan": "Teal Upright Half",
  "block.minecraft.banner.half_vertical.gray": "Gray Upright Half",
  "block.minecraft.banner.half_vertical.green": "Green Upright Half",
  "block.minecraft.banner.half_vertical.light_blue": "Light Bloe Upright Half",
  "block.minecraft.banner.half_vertical.light_gray": "Light Gray Upright Half",
  "block.minecraft.banner.half_vertical.lime": "Light Green Upright Half",
  "block.minecraft.banner.half_vertical.magenta": "Light Purple Upright Half",
  "block.minecraft.banner.half_vertical.orange": "Yellowred Upright Half",
  "block.minecraft.banner.half_vertical.pink": "Bleak Red Upright Half",
  "block.minecraft.banner.half_vertical.purple": "Purple Upright Half",
  "block.minecraft.banner.half_vertical.red": "Red Upright Half",
  "block.minecraft.banner.half_vertical.white": "White Upright Half",
  "block.minecraft.banner.half_vertical.yellow": "Yellow Upright Half",
  "block.minecraft.banner.half_vertical_right.black": "Black Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.blue": "Bloe Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.brown": "Brown Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.cyan": "Teal Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.gray": "Gray Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.green": "Green Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.light_blue": "Light Bloe Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.light_gray": "Light Gray Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.lime": "Light Green Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.magenta": "Light Purple Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.orange": "Yellowred Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.pink": "Bleak Red Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.purple": "Purple Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.red": "Red Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.white": "White Upright Half Right Side",
  "block.minecraft.banner.half_vertical_right.yellow": "Yellow Upright Half Right Side",
  "block.minecraft.banner.mojang.black": "Black Thing",
  "block.minecraft.banner.mojang.blue": "Bloe Thing",
  "block.minecraft.banner.mojang.brown": "Brown Thing",
  "block.minecraft.banner.mojang.cyan": "Teal Thing",
  "block.minecraft.banner.mojang.gray": "Gray Thing",
  "block.minecraft.banner.mojang.green": "Green Thing",
  "block.minecraft.banner.mojang.light_blue": "Light Bloe Thing",
  "block.minecraft.banner.mojang.light_gray": "Light Gray Thing",
  "block.minecraft.banner.mojang.lime": "Light Green Thing",
  "block.minecraft.banner.mojang.magenta": "Light Purple Thing",
  "block.minecraft.banner.mojang.orange": "Yellowred Thing",
  "block.minecraft.banner.mojang.pink": "Bleak Red Thing",
  "block.minecraft.banner.mojang.purple": "Purple Thing",
  "block.minecraft.banner.mojang.red": "Red Thing",
  "block.minecraft.banner.mojang.white": "White Thing",
  "block.minecraft.banner.mojang.yellow": "Yellow Thing",
  "block.minecraft.banner.piglin.black": "Black Snout",
  "block.minecraft.banner.piglin.blue": "Bloe Snout",
  "block.minecraft.banner.piglin.brown": "Brown Snout",
  "block.minecraft.banner.piglin.cyan": "Teal Snout",
  "block.minecraft.banner.piglin.gray": "Gray Snout",
  "block.minecraft.banner.piglin.green": "Green Snout",
  "block.minecraft.banner.piglin.light_blue": "Light Bloe Snout",
  "block.minecraft.banner.piglin.light_gray": "Light Gray Snout",
  "block.minecraft.banner.piglin.lime": "Light Green Snout",
  "block.minecraft.banner.piglin.magenta": "Light Purple Snout",
  "block.minecraft.banner.piglin.orange": "Yellowred Snout",
  "block.minecraft.banner.piglin.pink": "Bleak Red Snout",
  "block.minecraft.banner.piglin.purple": "Purple Snout",
  "block.minecraft.banner.piglin.red": "Red Snout",
  "block.minecraft.banner.piglin.white": "White Snout",
  "block.minecraft.banner.piglin.yellow": "Yellow Snout",
  "block.minecraft.banner.rhombus.black": "Black Kite",
  "block.minecraft.banner.rhombus.blue": "Bloe Kite",
  "block.minecraft.banner.rhombus.brown": "Brown Kite",
  "block.minecraft.banner.rhombus.cyan": "Teal Kite",
  "block.minecraft.banner.rhombus.gray": "Gray Kite",
  "block.minecraft.banner.rhombus.green": "Green Kite",
  "block.minecraft.banner.rhombus.light_blue": "Light Bloe Kite",
  "block.minecraft.banner.rhombus.light_gray": "Light Gray Kite",
  "block.minecraft.banner.rhombus.lime": "Light Green Kite",
  "block.minecraft.banner.rhombus.magenta": "Light Purple Kite",
  "block.minecraft.banner.rhombus.orange": "Yellowred Kite",
  "block.minecraft.banner.rhombus.pink": "Bleak Red Kite",
  "block.minecraft.banner.rhombus.purple": "Purple Kite",
  "block.minecraft.banner.rhombus.red": "Red Kite",
  "block.minecraft.banner.rhombus.white": "White Kite",
  "block.minecraft.banner.rhombus.yellow": "Yellow Kite",
  "block.minecraft.banner.skull.black": "Black Skull Shape",
  "block.minecraft.banner.skull.blue": "Bloe Skull Shape",
  "block.minecraft.banner.skull.brown": "Brown Skull Shape",
  "block.minecraft.banner.skull.cyan": "Teal Skull Shape",
  "block.minecraft.banner.skull.gray": "Gray Skull Shape",
  "block.minecraft.banner.skull.green": "Green Skull Shape",
  "block.minecraft.banner.skull.light_blue": "Light Bloe Skull Shape",
  "block.minecraft.banner.skull.light_gray": "Light Gray Skull Shape",
  "block.minecraft.banner.skull.lime": "Light Green Skull Shape",
  "block.minecraft.banner.skull.magenta": "Light Purple Skull Shape",
  "block.minecraft.banner.skull.orange": "Yellowred Skull Shape",
  "block.minecraft.banner.skull.pink": "Bleak Red Skull Shape",
  "block.minecraft.banner.skull.purple": "Purple Skull Shape",
  "block.minecraft.banner.skull.red": "Red Skull Shape",
  "block.minecraft.banner.skull.white": "White Skull Shape",
  "block.minecraft.banner.skull.yellow": "Yellow Skull Shape",
  "block.minecraft.banner.small_stripes.black": "Black Standing Streaks",
  "block.minecraft.banner.small_stripes.blue": "Bloe Standing Streaks",
  "block.minecraft.banner.small_stripes.brown": "Brown Standing Streaks",
  "block.minecraft.banner.small_stripes.cyan": "Teal Standing Streaks",
  "block.minecraft.banner.small_stripes.gray": "Gray Standing Streaks",
  "block.minecraft.banner.small_stripes.green": "Green Standing Streaks",
  "block.minecraft.banner.small_stripes.light_blue": "Light Bloe Standing Streaks",
  "block.minecraft.banner.small_stripes.light_gray": "Light Gray Standing Streaks",
  "block.minecraft.banner.small_stripes.lime": "Light Green Standing Streaks",
  "block.minecraft.banner.small_stripes.magenta": "Light Purple Standing Streaks",
  "block.minecraft.banner.small_stripes.orange": "Yellowred Standing Streaks",
  "block.minecraft.banner.small_stripes.pink": "Bleak Red Standing Streaks",
  "block.minecraft.banner.small_stripes.purple": "Purple Standing Streaks",
  "block.minecraft.banner.small_stripes.red": "Red Standing Streaks",
  "block.minecraft.banner.small_stripes.white": "White Standing Streaks",
  "block.minecraft.banner.small_stripes.yellow": "Yellow Standing Streaks",
  "block.minecraft.banner.square_bottom_left.black": "Black Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.blue": "Bloe Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.brown": "Brown Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.cyan": "Teal Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.gray": "Gray Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.green": "Green Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.light_blue": "Light Bloe Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.light_gray": "Light Gray Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.lime": "Light Green Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.magenta": "Light Purple Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.orange": "Yellowred Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.pink": "Bleak Red Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.purple": "Purple Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.red": "Red Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.white": "White Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_left.yellow": "Yellow Bottom Right Hirn",
  "block.minecraft.banner.square_bottom_right.black": "Black Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.blue": "Bloe Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.brown": "Brown Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.cyan": "Teal Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.gray": "Gray Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.green": "Green Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.light_blue": "Light Bloe Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.light_gray": "Light Gray Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.lime": "Light Green Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.magenta": "Light Purple Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.orange": "Yellowred Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.pink": "Bleak Red Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.purple": "Purple Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.red": "Red Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.white": "White Bottom Left Hirn",
  "block.minecraft.banner.square_bottom_right.yellow": "Yellow Bottom Left Hirn",
  "block.minecraft.banner.square_top_left.black": "Black Top Right Hirn",
  "block.minecraft.banner.square_top_left.blue": "Bloe Top Right Hirn",
  "block.minecraft.banner.square_top_left.brown": "Brown Top Right Hirn",
  "block.minecraft.banner.square_top_left.cyan": "Teal Top Right Hirn",
  "block.minecraft.banner.square_top_left.gray": "Gray Top Right Hirn",
  "block.minecraft.banner.square_top_left.green": "Green Top Right Hirn",
  "block.minecraft.banner.square_top_left.light_blue": "Light Bloe Top Right Hirn",
  "block.minecraft.banner.square_top_left.light_gray": "Light Gray Top Right Hirn",
  "block.minecraft.banner.square_top_left.lime": "Light Green Top Right Hirn",
  "block.minecraft.banner.square_top_left.magenta": "Light Purple Top Right Hirn",
  "block.minecraft.banner.square_top_left.orange": "Yellowred Top Right Hirn",
  "block.minecraft.banner.square_top_left.pink": "Bleak Red Top Right Hirn",
  "block.minecraft.banner.square_top_left.purple": "Purple Top Right Hirn",
  "block.minecraft.banner.square_top_left.red": "Red Top Right Hirn",
  "block.minecraft.banner.square_top_left.white": "White Top Right Hirn",
  "block.minecraft.banner.square_top_left.yellow": "Yellow Top Right Hirn",
  "block.minecraft.banner.square_top_right.black": "Black Top Left Hirn",
  "block.minecraft.banner.square_top_right.blue": "Bloe Top Left Hirn",
  "block.minecraft.banner.square_top_right.brown": "Brown Top Left Hirn",
  "block.minecraft.banner.square_top_right.cyan": "Teal Top Left Hirn",
  "block.minecraft.banner.square_top_right.gray": "Gray Top Left Hirn",
  "block.minecraft.banner.square_top_right.green": "Green Top Left Hirn",
  "block.minecraft.banner.square_top_right.light_blue": "Light Bloe Top Left Hirn",
  "block.minecraft.banner.square_top_right.light_gray": "Light Gray Top Left Hirn",
  "block.minecraft.banner.square_top_right.lime": "Light Green Top Left Hirn",
  "block.minecraft.banner.square_top_right.magenta": "Light Purple Top Left Hirn",
  "block.minecraft.banner.square_top_right.orange": "Yellowred Top Left Hirn",
  "block.minecraft.banner.square_top_right.pink": "Bleak Red Top Left Hirn",
  "block.minecraft.banner.square_top_right.purple": "Purple Top Left Hirn",
  "block.minecraft.banner.square_top_right.red": "Red Top Left Hirn",
  "block.minecraft.banner.square_top_right.white": "White Top Left Hirn",
  "block.minecraft.banner.square_top_right.yellow": "Yellow Top Left Hirn",
  "block.minecraft.banner.straight_cross.black": "Black Cross",
  "block.minecraft.banner.straight_cross.blue": "Bloe Cross",
  "block.minecraft.banner.straight_cross.brown": "Brown Cross",
  "block.minecraft.banner.straight_cross.cyan": "Teal Cross",
  "block.minecraft.banner.straight_cross.gray": "Gray Cross",
  "block.minecraft.banner.straight_cross.green": "Green Cross",
  "block.minecraft.banner.straight_cross.light_blue": "Light Bloe Cross",
  "block.minecraft.banner.straight_cross.light_gray": "Light Gray Cross",
  "block.minecraft.banner.straight_cross.lime": "Light Green Cross",
  "block.minecraft.banner.straight_cross.magenta": "Light Purple Cross",
  "block.minecraft.banner.straight_cross.orange": "Yellowred Cross",
  "block.minecraft.banner.straight_cross.pink": "Bleak Red Cross",
  "block.minecraft.banner.straight_cross.purple": "Purple Cross",
  "block.minecraft.banner.straight_cross.red": "Red Cross",
  "block.minecraft.banner.straight_cross.white": "White Cross",
  "block.minecraft.banner.straight_cross.yellow": "Yellow Cross",
  "block.minecraft.banner.stripe_bottom.black": "Black Bottom",
  "block.minecraft.banner.stripe_bottom.blue": "Bloe Bottom",
  "block.minecraft.banner.stripe_bottom.brown": "Brown Bottom",
  "block.minecraft.banner.stripe_bottom.cyan": "Teal Bottom",
  "block.minecraft.banner.stripe_bottom.gray": "Gray Bottom",
  "block.minecraft.banner.stripe_bottom.green": "Green Bottom",
  "block.minecraft.banner.stripe_bottom.light_blue": "Light Bloe Bottom",
  "block.minecraft.banner.stripe_bottom.light_gray": "Light Gray Bottom",
  "block.minecraft.banner.stripe_bottom.lime": "Light Green Bottom",
  "block.minecraft.banner.stripe_bottom.magenta": "Light Purple Bottom",
  "block.minecraft.banner.stripe_bottom.orange": "Yellowred Bottom",
  "block.minecraft.banner.stripe_bottom.pink": "Bleak Red Bottom",
  "block.minecraft.banner.stripe_bottom.purple": "Purple Bottom",
  "block.minecraft.banner.stripe_bottom.red": "Red Bottom",
  "block.minecraft.banner.stripe_bottom.white": "White Bottom",
  "block.minecraft.banner.stripe_bottom.yellow": "Yellow Bottom",
  "block.minecraft.banner.stripe_center.black": "Black Thin Streak",
  "block.minecraft.banner.stripe_center.blue": "Bloe Thin Streak",
  "block.minecraft.banner.stripe_center.brown": "Brown Thin Streak",
  "block.minecraft.banner.stripe_center.cyan": "Teal Thin Streak",
  "block.minecraft.banner.stripe_center.gray": "Gray Thin Streak",
  "block.minecraft.banner.stripe_center.green": "Green Thin Streak",
  "block.minecraft.banner.stripe_center.light_blue": "Light Bloe Thin Streak",
  "block.minecraft.banner.stripe_center.light_gray": "Light Gray Thin Streak",
  "block.minecraft.banner.stripe_center.lime": "Light Green Thin Streak",
  "block.minecraft.banner.stripe_center.magenta": "Light Purple Thin Streak",
  "block.minecraft.banner.stripe_center.orange": "Yellowred Thin Streak",
  "block.minecraft.banner.stripe_center.pink": "Bleak Red Thin Streak",
  "block.minecraft.banner.stripe_center.purple": "Purple Thin Streak",
  "block.minecraft.banner.stripe_center.red": "Red Thin Streak",
  "block.minecraft.banner.stripe_center.white": "White Thin Streak",
  "block.minecraft.banner.stripe_center.yellow": "Yellow Thin Streak",
  "block.minecraft.banner.stripe_downleft.black": "Black Left Bend",
  "block.minecraft.banner.stripe_downleft.blue": "Bloe Left Bend",
  "block.minecraft.banner.stripe_downleft.brown": "Brown Left Bend",
  "block.minecraft.banner.stripe_downleft.cyan": "Teal Left Bend",
  "block.minecraft.banner.stripe_downleft.gray": "Gray Left Bend",
  "block.minecraft.banner.stripe_downleft.green": "Green Left Bend",
  "block.minecraft.banner.stripe_downleft.light_blue": "Light Bloe Left Bend",
  "block.minecraft.banner.stripe_downleft.light_gray": "Light Gray Left Bend",
  "block.minecraft.banner.stripe_downleft.lime": "Light Green Left Bend",
  "block.minecraft.banner.stripe_downleft.magenta": "Light Purple Left Bend",
  "block.minecraft.banner.stripe_downleft.orange": "Yellowred Left Bend",
  "block.minecraft.banner.stripe_downleft.pink": "Bleak Red Left Bend",
  "block.minecraft.banner.stripe_downleft.purple": "Purple Left Bend",
  "block.minecraft.banner.stripe_downleft.red": "Red Left Bend",
  "block.minecraft.banner.stripe_downleft.white": "White Left Bend",
  "block.minecraft.banner.stripe_downleft.yellow": "Yellow Left Bend",
  "block.minecraft.banner.stripe_downright.black": "Black Bend",
  "block.minecraft.banner.stripe_downright.blue": "Bloe Bend",
  "block.minecraft.banner.stripe_downright.brown": "Brown Bend",
  "block.minecraft.banner.stripe_downright.cyan": "Teal Bend",
  "block.minecraft.banner.stripe_downright.gray": "Gray Bend",
  "block.minecraft.banner.stripe_downright.green": "Green Bend",
  "block.minecraft.banner.stripe_downright.light_blue": "Light Bloe Bend",
  "block.minecraft.banner.stripe_downright.light_gray": "Light Gray Bend",
  "block.minecraft.banner.stripe_downright.lime": "Light Green Bend",
  "block.minecraft.banner.stripe_downright.magenta": "Light Purple Bend",
  "block.minecraft.banner.stripe_downright.orange": "Yellowred Bend",
  "block.minecraft.banner.stripe_downright.pink": "Bleak Red Bend",
  "block.minecraft.banner.stripe_downright.purple": "Purple Bend",
  "block.minecraft.banner.stripe_downright.red": "Red Bend",
  "block.minecraft.banner.stripe_downright.white": "White Bend",
  "block.minecraft.banner.stripe_downright.yellow": "Yellow Bend",
  "block.minecraft.banner.stripe_left.black": "Black Left Thin Streak",
  "block.minecraft.banner.stripe_left.blue": "Bloe Left Thin Streak",
  "block.minecraft.banner.stripe_left.brown": "Brown Left Thin Streak",
  "block.minecraft.banner.stripe_left.cyan": "Teal Left Thin Streak",
  "block.minecraft.banner.stripe_left.gray": "Gray Left Thin Streak",
  "block.minecraft.banner.stripe_left.green": "Green Left Thin Streak",
  "block.minecraft.banner.stripe_left.light_blue": "Light Bloe Left Thin Streak",
  "block.minecraft.banner.stripe_left.light_gray": "Light Gray Left Thin Streak",
  "block.minecraft.banner.stripe_left.lime": "Light Green Left Thin Streak",
  "block.minecraft.banner.stripe_left.magenta": "Light Purple Left Thin Streak",
  "block.minecraft.banner.stripe_left.orange": "Yellowred Left Thin Streak",
  "block.minecraft.banner.stripe_left.pink": "Bleak Red Right Thin Streak",
  "block.minecraft.banner.stripe_left.purple": "Purple Left Thin Streak",
  "block.minecraft.banner.stripe_left.red": "Red Left Thin Streak",
  "block.minecraft.banner.stripe_left.white": "White Left Thin Streak",
  "block.minecraft.banner.stripe_left.yellow": "Yellow Left Thin Streak",
  "block.minecraft.banner.stripe_middle.black": "Black Middle Streak",
  "block.minecraft.banner.stripe_middle.blue": "Bloe Middle Streak",
  "block.minecraft.banner.stripe_middle.brown": "Brown Middle Streak",
  "block.minecraft.banner.stripe_middle.cyan": "Teal Middle Streak",
  "block.minecraft.banner.stripe_middle.gray": "Gray Middle Streak",
  "block.minecraft.banner.stripe_middle.green": "Green Middle Streak",
  "block.minecraft.banner.stripe_middle.light_blue": "Light Bloe Middle Streak",
  "block.minecraft.banner.stripe_middle.light_gray": "Light Gray Middle Streak",
  "block.minecraft.banner.stripe_middle.lime": "Light Green Middle Streak",
  "block.minecraft.banner.stripe_middle.magenta": "Light Purple Middle Streak",
  "block.minecraft.banner.stripe_middle.orange": "Yellowred Middle Streak",
  "block.minecraft.banner.stripe_middle.pink": "Bleak Red Middle Streak",
  "block.minecraft.banner.stripe_middle.purple": "Purple Middle Streak",
  "block.minecraft.banner.stripe_middle.red": "Red Middle Streak",
  "block.minecraft.banner.stripe_middle.white": "White Middle Streak",
  "block.minecraft.banner.stripe_middle.yellow": "Yellow Middle Streak",
  "block.minecraft.banner.stripe_right.black": "Black Right Thin Streak",
  "block.minecraft.banner.stripe_right.blue": "Bloe Right Thin Streak",
  "block.minecraft.banner.stripe_right.brown": "Brown Right Thin Streak",
  "block.minecraft.banner.stripe_right.cyan": "Teal Right Thin Streak",
  "block.minecraft.banner.stripe_right.gray": "Gray Right Thin Streak",
  "block.minecraft.banner.stripe_right.green": "Green Right Thin Streak",
  "block.minecraft.banner.stripe_right.light_blue": "Light Bloe Right Thin Streak",
  "block.minecraft.banner.stripe_right.light_gray": "Light Gray Right Thin Streak",
  "block.minecraft.banner.stripe_right.lime": "Light Green Right Thin Streak",
  "block.minecraft.banner.stripe_right.magenta": "Light Purple Right Thin Streak",
  "block.minecraft.banner.stripe_right.orange": "Yellowred Right Thin Streak",
  "block.minecraft.banner.stripe_right.pink": "Bleak Red Left Thin Streak",
  "block.minecraft.banner.stripe_right.purple": "Purple Right Thin Streak",
  "block.minecraft.banner.stripe_right.red": "Red Right Thin Streak",
  "block.minecraft.banner.stripe_right.white": "White Right Thin Streak",
  "block.minecraft.banner.stripe_right.yellow": "Yellow Right Thin Streak",
  "block.minecraft.banner.stripe_top.black": "Black Top",
  "block.minecraft.banner.stripe_top.blue": "Bloe Top",
  "block.minecraft.banner.stripe_top.brown": "Brown Top",
  "block.minecraft.banner.stripe_top.cyan": "Teal Top",
  "block.minecraft.banner.stripe_top.gray": "Gray Top",
  "block.minecraft.banner.stripe_top.green": "Green Top",
  "block.minecraft.banner.stripe_top.light_blue": "Light Bloe Top",
  "block.minecraft.banner.stripe_top.light_gray": "Light Gray Top",
  "block.minecraft.banner.stripe_top.lime": "Light Green Top",
  "block.minecraft.banner.stripe_top.magenta": "Light Purple Top",
  "block.minecraft.banner.stripe_top.orange": "Yellowred Top",
  "block.minecraft.banner.stripe_top.pink": "Bleak Red Top",
  "block.minecraft.banner.stripe_top.purple": "Purple Top",
  "block.minecraft.banner.stripe_top.red": "Red Top",
  "block.minecraft.banner.stripe_top.white": "White Top",
  "block.minecraft.banner.stripe_top.yellow": "Yellow Top",
  "block.minecraft.banner.triangle_bottom.black": "Black Threehirn",
  "block.minecraft.banner.triangle_bottom.blue": "Bloe Threehirn",
  "block.minecraft.banner.triangle_bottom.brown": "Brown Threehirn",
  "block.minecraft.banner.triangle_bottom.cyan": "Teal Threehirn",
  "block.minecraft.banner.triangle_bottom.gray": "Gray Threehirn",
  "block.minecraft.banner.triangle_bottom.green": "Green Threehirn",
  "block.minecraft.banner.triangle_bottom.light_blue": "Light Bloe Threehirn",
  "block.minecraft.banner.triangle_bottom.light_gray": "Light Gray Threehirn",
  "block.minecraft.banner.triangle_bottom.lime": "Light Green Threehirn",
  "block.minecraft.banner.triangle_bottom.magenta": "Light Purple Threehirn",
  "block.minecraft.banner.triangle_bottom.orange": "Yellowred Threehirn",
  "block.minecraft.banner.triangle_bottom.pink": "Bleak Red Threehirn",
  "block.minecraft.banner.triangle_bottom.purple": "Purple Threehirn",
  "block.minecraft.banner.triangle_bottom.red": "Red Threehirn",
  "block.minecraft.banner.triangle_bottom.white": "White Threehirn",
  "block.minecraft.banner.triangle_bottom.yellow": "Yellow Threehirn",
  "block.minecraft.banner.triangle_top.black": "Black Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.blue": "Bloe Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.brown": "Brown Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.cyan": "Teal Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.gray": "Gray Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.green": "Green Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.light_blue": "Light Bloe Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.light_gray": "Light Gray Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.lime": "Light Green Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.magenta": "Light Purple Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.orange": "Yellowred Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.pink": "Bleak Red Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.purple": "Purple Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.red": "Red Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.white": "White Upsodown Threehirn",
  "block.minecraft.banner.triangle_top.yellow": "Yellow Upsodown Threehirn",
  "block.minecraft.banner.triangles_bottom.black": "Black Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.blue": "Bloe Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.brown": "Brown Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.cyan": "Teal Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.gray": "Gray Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.green": "Green Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.light_blue": "Light Bloe Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.light_gray": "Light Gray Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.lime": "Light Green Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.magenta": "Light Purple Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.orange": "Yellowred Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.pink": "Bleak Red Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.purple": "Purple Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.red": "Red Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.white": "White Sawtoothed Bottom",
  "block.minecraft.banner.triangles_bottom.yellow": "Yellow Sawtoothed Bottom",
  "block.minecraft.banner.triangles_top.black": "Black Sawtoothed Top",
  "block.minecraft.banner.triangles_top.blue": "Bloe Sawtoothed Top",
  "block.minecraft.banner.triangles_top.brown": "Brown Sawtoothed Top",
  "block.minecraft.banner.triangles_top.cyan": "Teal Sawtoothed Top",
  "block.minecraft.banner.triangles_top.gray": "Gray Sawtoothed Top",
  "block.minecraft.banner.triangles_top.green": "Green Sawtoothed Top",
  "block.minecraft.banner.triangles_top.light_blue": "Light Bloe Sawtoothed Top",
  "block.minecraft.banner.triangles_top.light_gray": "Light Gray Sawtoothed Top",
  "block.minecraft.banner.triangles_top.lime": "Light Green Sawtoothed Top",
  "block.minecraft.banner.triangles_top.magenta": "Light Purple Sawtoothed Top",
  "block.minecraft.banner.triangles_top.orange": "Yellowred Sawtoothed Top",
  "block.minecraft.banner.triangles_top.pink": "Bleak Red Sawtoothed Top",
  "block.minecraft.banner.triangles_top.purple": "Purple Sawtoothed Top",
  "block.minecraft.banner.triangles_top.red": "Red Sawtoothed Top",
  "block.minecraft.banner.triangles_top.white": "White Sawtoothed Top",
  "block.minecraft.banner.triangles_top.yellow": "Yellow Sawtoothed Top",
  "block.minecraft.barrel": "Hogshead",
  "block.minecraft.barrier": "Hinderer",
  "block.minecraft.basalt": "Rinestone",
  "block.minecraft.beacon": "Beacon",
  "block.minecraft.beacon.primary": "Main Might",
  "block.minecraft.beacon.secondary": "Other Might",
  "block.minecraft.bed.no_sleep": "You can sleep only at night and in thunderstorms",
  "block.minecraft.bed.not_safe": "You may not rest now; there are warries nearby",
  "block.minecraft.bed.obstructed": "This bed is hindered",
  "block.minecraft.bed.occupied": "This bed is nimmed",
  "block.minecraft.bed.too_far_away": "You may not rest now; the bed is too far away",
  "block.minecraft.bedrock": "Bedstone",
  "block.minecraft.bee_nest": "Bee Nest",
  "block.minecraft.beehive": "Beehive",
  "block.minecraft.beetroots": "Beetroots",
  "block.minecraft.bell": "Bell",
  "block.minecraft.big_dripleaf": "Big Dripleaf",
  "block.minecraft.big_dripleaf_stem": "Big Dripleaf Stem",
  "block.minecraft.birch_button": "Birch Knap",
  "block.minecraft.birch_door": "Birch Door",
  "block.minecraft.birch_fence": "Birch Edder",
  "block.minecraft.birch_fence_gate": "Birch Edder Gate",
  "block.minecraft.birch_hanging_sign": "Birch Hanging Token",
  "block.minecraft.birch_leaves": "Birch Leaves",
  "block.minecraft.birch_log": "Birch Log",
  "block.minecraft.birch_planks": "Birch Boards",
  "block.minecraft.birch_pressure_plate": "Birch Thrutch Tile",
  "block.minecraft.birch_sapling": "Birch Sapling",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Birch Token",
  "block.minecraft.birch_slab": "Birch Halfclot",
  "block.minecraft.birch_stairs": "Birch Stairs",
  "block.minecraft.birch_trapdoor": "Birch Trapdoor",
  "block.minecraft.birch_wall_hanging_sign": "Birch Wall Hanging Token",
  "block.minecraft.birch_wall_sign": "Birch Wall Token",
  "block.minecraft.birch_wood": "Birch Wood",
  "block.minecraft.black_banner": "Black Fane",
  "block.minecraft.black_bed": "Black Bed",
  "block.minecraft.black_candle": "Black Candle",
  "block.minecraft.black_candle_cake": "Cake with Black Candle",
  "block.minecraft.black_carpet": "Black Rug",
  "block.minecraft.black_concrete": "Black Stonelime",
  "block.minecraft.black_concrete_powder": "Black Stonelime Dust",
  "block.minecraft.black_glazed_terracotta": "Black Glazed Redware",
  "block.minecraft.black_shulker_box": "Black Shulker Box",
  "block.minecraft.black_stained_glass": "Black Hued Glass",
  "block.minecraft.black_stained_glass_pane": "Black Hued Glass Sheet",
  "block.minecraft.black_terracotta": "Black Redware",
  "block.minecraft.black_wool": "Black Wool",
  "block.minecraft.blackstone": "Blackstone",
  "block.minecraft.blackstone_slab": "Blackstone Halfclot",
  "block.minecraft.blackstone_stairs": "Blackstone Stairs",
  "block.minecraft.blackstone_wall": "Blackstone Wall",
  "block.minecraft.blast_furnace": "Blastkiln",
  "block.minecraft.blue_banner": "Bloe Fane",
  "block.minecraft.blue_bed": "Bloe Bed",
  "block.minecraft.blue_candle": "Bloe Candle",
  "block.minecraft.blue_candle_cake": "Cake with Bloe Candle",
  "block.minecraft.blue_carpet": "Bloe Rug",
  "block.minecraft.blue_concrete": "Bloe Stonelime",
  "block.minecraft.blue_concrete_powder": "Bloe Stonelime Dust",
  "block.minecraft.blue_glazed_terracotta": "Bloe Glazed Redware",
  "block.minecraft.blue_ice": "Bloe Ice",
  "block.minecraft.blue_orchid": "Bloe Ballockwort",
  "block.minecraft.blue_shulker_box": "Bloe Shulker Box",
  "block.minecraft.blue_stained_glass": "Bloe Hued Glass",
  "block.minecraft.blue_stained_glass_pane": "Bloe Hued Glass Sheet",
  "block.minecraft.blue_terracotta": "Bloe Redware",
  "block.minecraft.blue_wool": "Bloe Wool",
  "block.minecraft.bone_block": "Bone Clot",
  "block.minecraft.bookshelf": "Bookshelf",
  "block.minecraft.brain_coral": "Brain Blossomdeer",
  "block.minecraft.brain_coral_block": "Brain Blossomdeer Clot",
  "block.minecraft.brain_coral_fan": "Brain Blossomdeer Blower",
  "block.minecraft.brain_coral_wall_fan": "Brain Blossomdeer Wall Blower",
  "block.minecraft.brewing_stand": "Brewing Stand",
  "block.minecraft.brick_slab": "Tile Halfclot",
  "block.minecraft.brick_stairs": "Tile Stairs",
  "block.minecraft.brick_wall": "Tile Wall",
  "block.minecraft.bricks": "Tiles",
  "block.minecraft.brown_banner": "Brown Fane",
  "block.minecraft.brown_bed": "Brown Bed",
  "block.minecraft.brown_candle": "Brown Candle",
  "block.minecraft.brown_candle_cake": "Cake with Brown Candle",
  "block.minecraft.brown_carpet": "Brown Rug",
  "block.minecraft.brown_concrete": "Brown Stonelime",
  "block.minecraft.brown_concrete_powder": "Brown Stonelime Dust",
  "block.minecraft.brown_glazed_terracotta": "Brown Glazed Redware",
  "block.minecraft.brown_mushroom": "Brown Swamb",
  "block.minecraft.brown_mushroom_block": "Brown Swamb Clot",
  "block.minecraft.brown_shulker_box": "Brown Shulker Box",
  "block.minecraft.brown_stained_glass": "Brown Hued Glass",
  "block.minecraft.brown_stained_glass_pane": "Brown Hued Glass Sheet",
  "block.minecraft.brown_terracotta": "Brown Redware",
  "block.minecraft.brown_wool": "Brown Wool",
  "block.minecraft.bubble_column": "Bubble Staple",
  "block.minecraft.bubble_coral": "Bubble Blossomdeer",
  "block.minecraft.bubble_coral_block": "Bubble Blossomdeer Clot",
  "block.minecraft.bubble_coral_fan": "Bubble Blossomdeer Blower",
  "block.minecraft.bubble_coral_wall_fan": "Bubble Blossomdeer Wall Blower",
  "block.minecraft.budding_amethyst": "Sprouting Drunklack",
  "block.minecraft.bush": "Bush",
  "block.minecraft.cactus": "Thorntree",
  "block.minecraft.cactus_flower": "Thorntree Bloom",
  "block.minecraft.cake": "Cake",
  "block.minecraft.calcite": "Chalkstone",
  "block.minecraft.calibrated_sculk_sensor": "Picky Sculk Feeler",
  "block.minecraft.campfire": "Bonfire",
  "block.minecraft.candle": "Candle",
  "block.minecraft.candle_cake": "Cake with Candle",
  "block.minecraft.carrots": "Walmores",
  "block.minecraft.cartography_table": "Drafting Bench",
  "block.minecraft.carved_pumpkin": "Carved Harvestovet",
  "block.minecraft.cauldron": "Ironcrock",
  "block.minecraft.cave_air": "Shraff Lift",
  "block.minecraft.cave_vines": "Shraff Winetrees",
  "block.minecraft.cave_vines_plant": "Shraff Winetrees Wort",
  "block.minecraft.chain": "Rackent",
  "block.minecraft.chain_command_block": "Rackent Hest Clot",
  "block.minecraft.cherry_button": "Chirse Knap",
  "block.minecraft.cherry_door": "Chirse Door",
  "block.minecraft.cherry_fence": "Chirse Edder",
  "block.minecraft.cherry_fence_gate": "Chirse Edder Gate",
  "block.minecraft.cherry_hanging_sign": "Chirse Hanging Token",
  "block.minecraft.cherry_leaves": "Chirse Leaves",
  "block.minecraft.cherry_log": "Chirse Log",
  "block.minecraft.cherry_planks": "Chirse Boards",
  "block.minecraft.cherry_pressure_plate": "Chirse Thrutch Tile",
  "block.minecraft.cherry_sapling": "Chirse Sapling",
  "block.minecraft.cherry_shelf": "Chirse Shelf",
  "block.minecraft.cherry_sign": "Chirse Token",
  "block.minecraft.cherry_slab": "Chirse Halfclot",
  "block.minecraft.cherry_stairs": "Chirse Stairs",
  "block.minecraft.cherry_trapdoor": "Chirse Trapdoor",
  "block.minecraft.cherry_wall_hanging_sign": "Chirse Wall Hanging Token",
  "block.minecraft.cherry_wall_sign": "Chirse Wall Token",
  "block.minecraft.cherry_wood": "Chirse Wood",
  "block.minecraft.chest": "Chest",
  "block.minecraft.chipped_anvil": "Chipped Anvil",
  "block.minecraft.chiseled_bookshelf": "Graven Bookshelf",
  "block.minecraft.chiseled_copper": "Graven Copper",
  "block.minecraft.chiseled_deepslate": "Graven Deepstone",
  "block.minecraft.chiseled_nether_bricks": "Graven Nether Tiles",
  "block.minecraft.chiseled_polished_blackstone": "Graven Sliked Blackstone",
  "block.minecraft.chiseled_quartz_block": "Graven Hardstone Clot",
  "block.minecraft.chiseled_red_sandstone": "Graven Red Sandstone",
  "block.minecraft.chiseled_resin_bricks": "Graven Glar Tiles",
  "block.minecraft.chiseled_sandstone": "Graven Sandstone",
  "block.minecraft.chiseled_stone_bricks": "Graven Stone Wallstones",
  "block.minecraft.chiseled_tuff": "Graven Ashstone",
  "block.minecraft.chiseled_tuff_bricks": "Graven Ashstone Wallstones",
  "block.minecraft.chorus_flower": "Chorbloom",
  "block.minecraft.chorus_plant": "Chorwort",
  "block.minecraft.clay": "Clay",
  "block.minecraft.closed_eyeblossom": "Shut Eyeblossom",
  "block.minecraft.coal_block": "Coal Clot",
  "block.minecraft.coal_ore": "Coal Ore",
  "block.minecraft.coarse_dirt": "Rough Dirt",
  "block.minecraft.cobbled_deepslate": "Cobbled Deepstone",
  "block.minecraft.cobbled_deepslate_slab": "Cobbled Deepstone Halfclot",
  "block.minecraft.cobbled_deepslate_stairs": "Cobbled Deepstone Stairs",
  "block.minecraft.cobbled_deepslate_wall": "Cobbled Deepstone Wall",
  "block.minecraft.cobblestone": "Cobblestone",
  "block.minecraft.cobblestone_slab": "Cobblestone Halfclot",
  "block.minecraft.cobblestone_stairs": "Cobblestone Stairs",
  "block.minecraft.cobblestone_wall": "Cobblestone Wall",
  "block.minecraft.cobweb": "Cobweb",
  "block.minecraft.cocoa": "Cocoa",
  "block.minecraft.command_block": "Hest Clot",
  "block.minecraft.comparator": "Redstone Bemeter",
  "block.minecraft.composter": "Dungminger",
  "block.minecraft.conduit": "Ithelode",
  "block.minecraft.copper_bars": "Copper Rods",
  "block.minecraft.copper_block": "Copper Clot",
  "block.minecraft.copper_bulb": "Copper Lightvat",
  "block.minecraft.copper_chain": "Copper Rackent",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Copper Door",
  "block.minecraft.copper_golem_statue": "Coppergolem Graft",
  "block.minecraft.copper_grate": "Copper Hurdle",
  "block.minecraft.copper_lantern": "Copper Bloakern",
  "block.minecraft.copper_ore": "Copper Ore",
  "block.minecraft.copper_torch": "Copper Brand",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Copper Wall Brand",
  "block.minecraft.cornflower": "Cornbloom",
  "block.minecraft.cracked_deepslate_bricks": "Cracked Deepstone Wallstones",
  "block.minecraft.cracked_deepslate_tiles": "Cracked Deepstone Tiles",
  "block.minecraft.cracked_nether_bricks": "Cracked Nether Tiles",
  "block.minecraft.cracked_polished_blackstone_bricks": "Cracked Sliked Blackstone Wallstones",
  "block.minecraft.cracked_stone_bricks": "Cracked Stone Wallstones",
  "block.minecraft.crafter": "Crafter",
  "block.minecraft.crafting_table": "Workbench",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Creeper Head",
  "block.minecraft.creeper_wall_head": "Creeper Wall Head",
  "block.minecraft.crimson_button": "Baze Knap",
  "block.minecraft.crimson_door": "Baze Door",
  "block.minecraft.crimson_fence": "Baze Edder",
  "block.minecraft.crimson_fence_gate": "Baze Edder Gate",
  "block.minecraft.crimson_fungus": "Baze Swamb",
  "block.minecraft.crimson_hanging_sign": "Baze Hanging Token",
  "block.minecraft.crimson_hyphae": "Baze Swambwire",
  "block.minecraft.crimson_nylium": "Baze Swambmerthe",
  "block.minecraft.crimson_planks": "Baze Boards",
  "block.minecraft.crimson_pressure_plate": "Baze Thrutch Tile",
  "block.minecraft.crimson_roots": "Baze Roots",
  "block.minecraft.crimson_shelf": "Baze Shelf",
  "block.minecraft.crimson_sign": "Baze Token",
  "block.minecraft.crimson_slab": "Baze Halfclot",
  "block.minecraft.crimson_stairs": "Baze Stairs",
  "block.minecraft.crimson_stem": "Baze Stem",
  "block.minecraft.crimson_trapdoor": "Baze Trapdoor",
  "block.minecraft.crimson_wall_hanging_sign": "Baze Wall Hanging Token",
  "block.minecraft.crimson_wall_sign": "Baze Wall Token",
  "block.minecraft.crying_obsidian": "Weeping Ravenglass",
  "block.minecraft.cut_copper": "Cut Copper",
  "block.minecraft.cut_copper_slab": "Cut Copper Halfclot",
  "block.minecraft.cut_copper_stairs": "Cut Copper Stairs",
  "block.minecraft.cut_red_sandstone": "Cut Red Sandstone",
  "block.minecraft.cut_red_sandstone_slab": "Cut Red Sandstone Halfclot",
  "block.minecraft.cut_sandstone": "Cut Sandstone",
  "block.minecraft.cut_sandstone_slab": "Cut Sandstone Halfclot",
  "block.minecraft.cyan_banner": "Teal Fane",
  "block.minecraft.cyan_bed": "Teal Bed",
  "block.minecraft.cyan_candle": "Teal Candle",
  "block.minecraft.cyan_candle_cake": "Cake with Teal Candle",
  "block.minecraft.cyan_carpet": "Teal Rug",
  "block.minecraft.cyan_concrete": "Teal Stonelime",
  "block.minecraft.cyan_concrete_powder": "Teal Stonelime Dust",
  "block.minecraft.cyan_glazed_terracotta": "Teal Glazed Redware",
  "block.minecraft.cyan_shulker_box": "Teal Shulker Box",
  "block.minecraft.cyan_stained_glass": "Teal Hued Glass",
  "block.minecraft.cyan_stained_glass_pane": "Teal Hued Glass Sheet",
  "block.minecraft.cyan_terracotta": "Teal Redware",
  "block.minecraft.cyan_wool": "Teal Wool",
  "block.minecraft.damaged_anvil": "Worn Anvil",
  "block.minecraft.dandelion": "Monkshead",
  "block.minecraft.dark_oak_button": "Dark Oak Knap",
  "block.minecraft.dark_oak_door": "Dark Oak Door",
  "block.minecraft.dark_oak_fence": "Dark Oak Edder",
  "block.minecraft.dark_oak_fence_gate": "Dark Oak Edder Gate",
  "block.minecraft.dark_oak_hanging_sign": "Dark Oak Hanging Token",
  "block.minecraft.dark_oak_leaves": "Dark Oak Leaves",
  "block.minecraft.dark_oak_log": "Dark Oak Log",
  "block.minecraft.dark_oak_planks": "Dark Oak Boards",
  "block.minecraft.dark_oak_pressure_plate": "Dark Oak Thrutch Tile",
  "block.minecraft.dark_oak_sapling": "Dark Oak Sapling",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Dark Oak Token",
  "block.minecraft.dark_oak_slab": "Dark Oak Halfclot",
  "block.minecraft.dark_oak_stairs": "Dark Oak Stairs",
  "block.minecraft.dark_oak_trapdoor": "Dark Oak Trapdoor",
  "block.minecraft.dark_oak_wall_hanging_sign": "Dark Oak Wall Hanging Token",
  "block.minecraft.dark_oak_wall_sign": "Dark Oak Wall Token",
  "block.minecraft.dark_oak_wood": "Dark Oak Wood",
  "block.minecraft.dark_prismarine": "Dark Prismarine",
  "block.minecraft.dark_prismarine_slab": "Dark Prismarine Halfclot",
  "block.minecraft.dark_prismarine_stairs": "Dark Prismarine Stairs",
  "block.minecraft.daylight_detector": "Daylight Acknower",
  "block.minecraft.dead_brain_coral": "Dead Brain Blossomdeer",
  "block.minecraft.dead_brain_coral_block": "Dead Brain Blossomdeer Clot",
  "block.minecraft.dead_brain_coral_fan": "Dead Brain Blossomdeer Blower",
  "block.minecraft.dead_brain_coral_wall_fan": "Dead Brain Blossomdeer Wall Blower",
  "block.minecraft.dead_bubble_coral": "Dead Bubble Blossomdeer",
  "block.minecraft.dead_bubble_coral_block": "Dead Bubble Blossomdeer Clot",
  "block.minecraft.dead_bubble_coral_fan": "Dead Bubble Blossomdeer Blower",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dead Bubble Blossomdeer Wall Blower",
  "block.minecraft.dead_bush": "Dead Bush",
  "block.minecraft.dead_fire_coral": "Dead Fire Blossomdeer",
  "block.minecraft.dead_fire_coral_block": "Dead Fire Blossomdeer Clot",
  "block.minecraft.dead_fire_coral_fan": "Dead Fire Blossomdeer Blower",
  "block.minecraft.dead_fire_coral_wall_fan": "Dead Fire Blossomdeer Wall Blower",
  "block.minecraft.dead_horn_coral": "Dead Horn Blossomdeer",
  "block.minecraft.dead_horn_coral_block": "Dead Horn Blossomdeer Clot",
  "block.minecraft.dead_horn_coral_fan": "Dead Horn Blossomdeer Blower",
  "block.minecraft.dead_horn_coral_wall_fan": "Dead Horn Blossomdeer Wall Blower",
  "block.minecraft.dead_tube_coral": "Dead Theet Blossomdeer",
  "block.minecraft.dead_tube_coral_block": "Dead Theet Blossomdeer Clot",
  "block.minecraft.dead_tube_coral_fan": "Dead Theet Blossomdeer Blower",
  "block.minecraft.dead_tube_coral_wall_fan": "Dead Theet Blossomdeer Wall Blower",
  "block.minecraft.decorated_pot": "Fratowed Pot",
  "block.minecraft.deepslate": "Deepstone",
  "block.minecraft.deepslate_brick_slab": "Deepstone Wallstone Halfclot",
  "block.minecraft.deepslate_brick_stairs": "Deepstone Wallstone Stairs",
  "block.minecraft.deepslate_brick_wall": "Deepstone Wallstone Wall",
  "block.minecraft.deepslate_bricks": "Deepstone Wallstones",
  "block.minecraft.deepslate_coal_ore": "Deepstone Coal Ore",
  "block.minecraft.deepslate_copper_ore": "Deepstone Copper Ore",
  "block.minecraft.deepslate_diamond_ore": "Deepstone Athamans Ore",
  "block.minecraft.deepslate_emerald_ore": "Deepstone Smaragd Ore",
  "block.minecraft.deepslate_gold_ore": "Deepstone Gold Ore",
  "block.minecraft.deepslate_iron_ore": "Deepstone Iron Ore",
  "block.minecraft.deepslate_lapis_ore": "Deepstone Hewnstone Ore",
  "block.minecraft.deepslate_redstone_ore": "Deepstone Redstone Ore",
  "block.minecraft.deepslate_tile_slab": "Deepstone Tile Halfclot",
  "block.minecraft.deepslate_tile_stairs": "Deepstone Tile Stairs",
  "block.minecraft.deepslate_tile_wall": "Deepstone Tile Wall",
  "block.minecraft.deepslate_tiles": "Deepstone Tiles",
  "block.minecraft.detector_rail": "Acknower Ironroad",
  "block.minecraft.diamond_block": "Athamans Clot",
  "block.minecraft.diamond_ore": "Athamans Ore",
  "block.minecraft.diorite": "Shedstone",
  "block.minecraft.diorite_slab": "Shedstone Halfclot",
  "block.minecraft.diorite_stairs": "Shedstone Stairs",
  "block.minecraft.diorite_wall": "Shedstone Wall",
  "block.minecraft.dirt": "Dirt",
  "block.minecraft.dirt_path": "Dirtpath",
  "block.minecraft.dispenser": "Thrower",
  "block.minecraft.dragon_egg": "Drake Egg",
  "block.minecraft.dragon_head": "Drake Head",
  "block.minecraft.dragon_wall_head": "Drake Wall Head",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Dried Kelp Clot",
  "block.minecraft.dripstone_block": "Dripstone Clot",
  "block.minecraft.dropper": "Dropper",
  "block.minecraft.emerald_block": "Smaragd Clot",
  "block.minecraft.emerald_ore": "Smaragd Ore",
  "block.minecraft.enchanting_table": "Goldering Bench",
  "block.minecraft.end_gateway": "End Gateway",
  "block.minecraft.end_portal": "End Ingang",
  "block.minecraft.end_portal_frame": "End Ingang Frame",
  "block.minecraft.end_rod": "End Rod",
  "block.minecraft.end_stone": "End Stone",
  "block.minecraft.end_stone_brick_slab": "End Stone Wallstone Halfclot",
  "block.minecraft.end_stone_brick_stairs": "End Stone Wallstone Stairs",
  "block.minecraft.end_stone_brick_wall": "End Stone Wallstone Wall",
  "block.minecraft.end_stone_bricks": "End Stone Wallstones",
  "block.minecraft.ender_chest": "Ender Chest",
  "block.minecraft.exposed_chiseled_copper": "Unwried Graven Copper",
  "block.minecraft.exposed_copper": "Unwried Copper",
  "block.minecraft.exposed_copper_bars": "Unwried Copper Rods",
  "block.minecraft.exposed_copper_bulb": "Unwried Copper Lightvat",
  "block.minecraft.exposed_copper_chain": "Unwried Copper Rackent",
  "block.minecraft.exposed_copper_chest": "Unwried Copper Chest",
  "block.minecraft.exposed_copper_door": "Unwried Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Unwried Coppergolem Graft",
  "block.minecraft.exposed_copper_grate": "Unwried Copper Hurdle",
  "block.minecraft.exposed_copper_lantern": "Unwried Copper Bloakern",
  "block.minecraft.exposed_copper_trapdoor": "Unwried Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "Unwried Cut Copper",
  "block.minecraft.exposed_cut_copper_slab": "Unwried Cut Copper Halfclot",
  "block.minecraft.exposed_cut_copper_stairs": "Unwried Cut Copper Stairs",
  "block.minecraft.exposed_lightning_rod": "Unwried Lightning Rod",
  "block.minecraft.farmland": "Cropland",
  "block.minecraft.fern": "Fern",
  "block.minecraft.fire": "Fire",
  "block.minecraft.fire_coral": "Fire Blossomdeer",
  "block.minecraft.fire_coral_block": "Fire Blossomdeer Clot",
  "block.minecraft.fire_coral_fan": "Fire Blossomdeer Blower",
  "block.minecraft.fire_coral_wall_fan": "Fire Blossomdeer Wall Blower",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Arrowmaking Bench",
  "block.minecraft.flower_pot": "Bloom Pot",
  "block.minecraft.flowering_azalea": "Blooming Drywort",
  "block.minecraft.flowering_azalea_leaves": "Blooming Drywort Leaves",
  "block.minecraft.frogspawn": "Frogeggs",
  "block.minecraft.frosted_ice": "Frosted Ice",
  "block.minecraft.furnace": "Kiln",
  "block.minecraft.gilded_blackstone": "Gilded Blackstone",
  "block.minecraft.glass": "Glass",
  "block.minecraft.glass_pane": "Glass Sheet",
  "block.minecraft.glow_lichen": "Glow Raw",
  "block.minecraft.glowstone": "Glowstone",
  "block.minecraft.gold_block": "Gold Clot",
  "block.minecraft.gold_ore": "Gold Ore",
  "block.minecraft.golden_dandelion": "Golden Monkshead",
  "block.minecraft.granite": "Cornstone",
  "block.minecraft.granite_slab": "Cornstone Halfclot",
  "block.minecraft.granite_stairs": "Cornstone Stairs",
  "block.minecraft.granite_wall": "Cornstone Wall",
  "block.minecraft.grass": "Grass",
  "block.minecraft.grass_block": "Grass Clot",
  "block.minecraft.gravel": "Chisel",
  "block.minecraft.gray_banner": "Gray Fane",
  "block.minecraft.gray_bed": "Gray Bed",
  "block.minecraft.gray_candle": "Gray Candle",
  "block.minecraft.gray_candle_cake": "Cake with Gray Candle",
  "block.minecraft.gray_carpet": "Gray Rug",
  "block.minecraft.gray_concrete": "Gray Stonelime",
  "block.minecraft.gray_concrete_powder": "Gray Stonelime Dust",
  "block.minecraft.gray_glazed_terracotta": "Gray Glazed Redware",
  "block.minecraft.gray_shulker_box": "Gray Shulker Box",
  "block.minecraft.gray_stained_glass": "Gray Hued Glass",
  "block.minecraft.gray_stained_glass_pane": "Gray Hued Glass Sheet",
  "block.minecraft.gray_terracotta": "Gray Redware",
  "block.minecraft.gray_wool": "Gray Wool",
  "block.minecraft.green_banner": "Green Fane",
  "block.minecraft.green_bed": "Green Bed",
  "block.minecraft.green_candle": "Green Candle",
  "block.minecraft.green_candle_cake": "Cake with Green Candle",
  "block.minecraft.green_carpet": "Green Rug",
  "block.minecraft.green_concrete": "Green Stonelime",
  "block.minecraft.green_concrete_powder": "Green Stonelime Dust",
  "block.minecraft.green_glazed_terracotta": "Green Glazed Redware",
  "block.minecraft.green_shulker_box": "Green Shulker Box",
  "block.minecraft.green_stained_glass": "Green Hued Glass",
  "block.minecraft.green_stained_glass_pane": "Green Hued Glass Sheet",
  "block.minecraft.green_terracotta": "Green Redware",
  "block.minecraft.green_wool": "Green Wool",
  "block.minecraft.grindstone": "Grindstone",
  "block.minecraft.hanging_roots": "Hanging Roots",
  "block.minecraft.hay_block": "Hay",
  "block.minecraft.heavy_core": "Heavy Heart",
  "block.minecraft.heavy_weighted_pressure_plate": "Heavy Weighted Thrutch Tile",
  "block.minecraft.honey_block": "Honey Clot",
  "block.minecraft.honeycomb_block": "Honeycomb Clot",
  "block.minecraft.hopper": "Hopper",
  "block.minecraft.horn_coral": "Horn Blossomdeer",
  "block.minecraft.horn_coral_block": "Horn Blossomdeer Clot",
  "block.minecraft.horn_coral_fan": "Horn Blossomdeer Blower",
  "block.minecraft.horn_coral_wall_fan": "Horn Blossomdeer Wall Blower",
  "block.minecraft.ice": "Ice",
  "block.minecraft.infested_chiseled_stone_bricks": "Beridden Graven Stone Wallstones",
  "block.minecraft.infested_cobblestone": "Beridden Cobblestone",
  "block.minecraft.infested_cracked_stone_bricks": "Beridden Cracked Stone Wallstones",
  "block.minecraft.infested_deepslate": "Beridden Deepstone",
  "block.minecraft.infested_mossy_stone_bricks": "Beridden Mossy Stone Wallstones",
  "block.minecraft.infested_stone": "Beridden Stone",
  "block.minecraft.infested_stone_bricks": "Beridden Stone Wallstones",
  "block.minecraft.iron_bars": "Iron Rods",
  "block.minecraft.iron_block": "Iron Clot",
  "block.minecraft.iron_chain": "Iron Rackent",
  "block.minecraft.iron_door": "Iron Door",
  "block.minecraft.iron_ore": "Iron Ore",
  "block.minecraft.iron_trapdoor": "Iron Trapdoor",
  "block.minecraft.jack_o_lantern": "Harvestovet Lightvat",
  "block.minecraft.jigsaw": "Inlock Clot",
  "block.minecraft.jukebox": "Gleebox",
  "block.minecraft.jungle_button": "Rainwold Knap",
  "block.minecraft.jungle_door": "Rainwold Door",
  "block.minecraft.jungle_fence": "Rainwold Edder",
  "block.minecraft.jungle_fence_gate": "Rainwold Edder Gate",
  "block.minecraft.jungle_hanging_sign": "Rainwold Hanging Token",
  "block.minecraft.jungle_leaves": "Rainwold Leaves",
  "block.minecraft.jungle_log": "Rainwold Log",
  "block.minecraft.jungle_planks": "Rainwold Boards",
  "block.minecraft.jungle_pressure_plate": "Rainwold Thrutch Tile",
  "block.minecraft.jungle_sapling": "Rainwold Sapling",
  "block.minecraft.jungle_shelf": "Rainwold Shelf",
  "block.minecraft.jungle_sign": "Rainwold Token",
  "block.minecraft.jungle_slab": "Rainwold Halfclot",
  "block.minecraft.jungle_stairs": "Rainwold Stairs",
  "block.minecraft.jungle_trapdoor": "Rainwold Trapdoor",
  "block.minecraft.jungle_wall_hanging_sign": "Rainwold Wall Hanging Token",
  "block.minecraft.jungle_wall_sign": "Rainwold Wall Token",
  "block.minecraft.jungle_wood": "Rainwold Wood",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Kelpwort",
  "block.minecraft.ladder": "Ladder",
  "block.minecraft.lantern": "Bloakern",
  "block.minecraft.lapis_block": "Hewnstone Clot",
  "block.minecraft.lapis_ore": "Hewnstone Ore",
  "block.minecraft.large_amethyst_bud": "Great Drunklack Sprout",
  "block.minecraft.large_fern": "Tall Fern",
  "block.minecraft.lava": "Moltenstone",
  "block.minecraft.lava_cauldron": "Moltenstone Ironcrock",
  "block.minecraft.leaf_litter": "Fallen Leaves",
  "block.minecraft.lectern": "Readingshamble",
  "block.minecraft.lever": "Heaver",
  "block.minecraft.light": "Light",
  "block.minecraft.light_blue_banner": "Light Bloe Fane",
  "block.minecraft.light_blue_bed": "Light Bloe Bed",
  "block.minecraft.light_blue_candle": "Light Bloe Candle",
  "block.minecraft.light_blue_candle_cake": "Cake with Light Bloe Candle",
  "block.minecraft.light_blue_carpet": "Light Bloe Rug",
  "block.minecraft.light_blue_concrete": "Light Bloe Stonelime",
  "block.minecraft.light_blue_concrete_powder": "Light Bloe Stonelime Dust",
  "block.minecraft.light_blue_glazed_terracotta": "Light Bloe Glazed Redware",
  "block.minecraft.light_blue_shulker_box": "Light Bloe Shulker Box",
  "block.minecraft.light_blue_stained_glass": "Light Bloe Hued Glass",
  "block.minecraft.light_blue_stained_glass_pane": "Light Bloe Hued Glass Sheet",
  "block.minecraft.light_blue_terracotta": "Light Bloe Redware",
  "block.minecraft.light_blue_wool": "Light Bloe Wool",
  "block.minecraft.light_gray_banner": "Light Gray Fane",
  "block.minecraft.light_gray_bed": "Light Gray Bed",
  "block.minecraft.light_gray_candle": "Light Gray Candle",
  "block.minecraft.light_gray_candle_cake": "Cake with Light Gray Candle",
  "block.minecraft.light_gray_carpet": "Light Gray Rug",
  "block.minecraft.light_gray_concrete": "Light Gray Stonelime",
  "block.minecraft.light_gray_concrete_powder": "Light Gray Stonelime Dust",
  "block.minecraft.light_gray_glazed_terracotta": "Light Gray Glazed Redware",
  "block.minecraft.light_gray_shulker_box": "Light Gray Shulker Box",
  "block.minecraft.light_gray_stained_glass": "Light Gray Hued Glass",
  "block.minecraft.light_gray_stained_glass_pane": "Light Gray Hued Glass Sheet",
  "block.minecraft.light_gray_terracotta": "Light Gray Redware",
  "block.minecraft.light_gray_wool": "Light Gray Wool",
  "block.minecraft.light_weighted_pressure_plate": "Light Weighted Thrutch Tile",
  "block.minecraft.lightning_rod": "Lightning Rod",
  "block.minecraft.lilac": "Bazebloom",
  "block.minecraft.lily_of_the_valley": "Glovewort",
  "block.minecraft.lily_pad": "Lilycrop",
  "block.minecraft.lime_banner": "Light Green Fane",
  "block.minecraft.lime_bed": "Light Green Bed",
  "block.minecraft.lime_candle": "Light Green Candle",
  "block.minecraft.lime_candle_cake": "Cake with Light Green Candle",
  "block.minecraft.lime_carpet": "Light Green Rug",
  "block.minecraft.lime_concrete": "Light Green Stonelime",
  "block.minecraft.lime_concrete_powder": "Light Green Stonelime Dust",
  "block.minecraft.lime_glazed_terracotta": "Light Green Glazed Redware",
  "block.minecraft.lime_shulker_box": "Light Green Shulker Box",
  "block.minecraft.lime_stained_glass": "Light Green Hued Glass",
  "block.minecraft.lime_stained_glass_pane": "Light Green Hued Glass Sheet",
  "block.minecraft.lime_terracotta": "Light Green Redware",
  "block.minecraft.lime_wool": "Light Green Wool",
  "block.minecraft.lodestone": "Lodestone",
  "block.minecraft.loom": "Loom",
  "block.minecraft.magenta_banner": "Light Purple Fane",
  "block.minecraft.magenta_bed": "Light Purple Bed",
  "block.minecraft.magenta_candle": "Light Purple Candle",
  "block.minecraft.magenta_candle_cake": "Cake with Light Purple Candle",
  "block.minecraft.magenta_carpet": "Light Purple Rug",
  "block.minecraft.magenta_concrete": "Light Purple Stonelime",
  "block.minecraft.magenta_concrete_powder": "Light Purple Stonelime Dust",
  "block.minecraft.magenta_glazed_terracotta": "Light Purple Glazed Redware",
  "block.minecraft.magenta_shulker_box": "Light Purple Shulker Box",
  "block.minecraft.magenta_stained_glass": "Light Purple Hued Glass",
  "block.minecraft.magenta_stained_glass_pane": "Light Purple Hued Glass Sheet",
  "block.minecraft.magenta_terracotta": "Light Purple Redware",
  "block.minecraft.magenta_wool": "Light Purple Wool",
  "block.minecraft.magma_block": "Moltenstone Clot",
  "block.minecraft.mangrove_button": "Brinetree Knap",
  "block.minecraft.mangrove_door": "Brinetree Door",
  "block.minecraft.mangrove_fence": "Brinetree Edder",
  "block.minecraft.mangrove_fence_gate": "Brinetree Edder Gate",
  "block.minecraft.mangrove_hanging_sign": "Brinetree Hanging Token",
  "block.minecraft.mangrove_leaves": "Brinetree Leaves",
  "block.minecraft.mangrove_log": "Brinetree Log",
  "block.minecraft.mangrove_planks": "Brinetree Boards",
  "block.minecraft.mangrove_pressure_plate": "Brinetree Thrutch Tile",
  "block.minecraft.mangrove_propagule": "Brinetree Spreadstem",
  "block.minecraft.mangrove_roots": "Brinetree Roots",
  "block.minecraft.mangrove_shelf": "Brinetree Shelf",
  "block.minecraft.mangrove_sign": "Brinetree Token",
  "block.minecraft.mangrove_slab": "Brinetree Halfclot",
  "block.minecraft.mangrove_stairs": "Brinetree Stairs",
  "block.minecraft.mangrove_trapdoor": "Brinetree Trapdoor",
  "block.minecraft.mangrove_wall_hanging_sign": "Brinetree Wall Hanging Token",
  "block.minecraft.mangrove_wall_sign": "Brinetree Wall Token",
  "block.minecraft.mangrove_wood": "Brinetree Wood",
  "block.minecraft.medium_amethyst_bud": "Middling Drunklack Sprout",
  "block.minecraft.melon": "Entapple",
  "block.minecraft.melon_stem": "Entapple Stem",
  "block.minecraft.moss_block": "Moss Clot",
  "block.minecraft.moss_carpet": "Moss Rug",
  "block.minecraft.mossy_cobblestone": "Mossy Cobblestone",
  "block.minecraft.mossy_cobblestone_slab": "Mossy Cobblestone Halfclot",
  "block.minecraft.mossy_cobblestone_stairs": "Mossy Cobblestone Stairs",
  "block.minecraft.mossy_cobblestone_wall": "Mossy Cobblestone Wall",
  "block.minecraft.mossy_stone_brick_slab": "Mossy Stone Wallstone Halfclot",
  "block.minecraft.mossy_stone_brick_stairs": "Mossy Stone Wallstone Stairs",
  "block.minecraft.mossy_stone_brick_wall": "Mossy Stone Wallstone Wall",
  "block.minecraft.mossy_stone_bricks": "Mossy Stone Wallstones",
  "block.minecraft.moving_piston": "Shifting Sucker",
  "block.minecraft.mud": "Mud",
  "block.minecraft.mud_brick_slab": "Mud Wallstone Halfclot",
  "block.minecraft.mud_brick_stairs": "Mud Wallstone Stairs",
  "block.minecraft.mud_brick_wall": "Mud Wallstone Wall",
  "block.minecraft.mud_bricks": "Mud Wallstones",
  "block.minecraft.muddy_mangrove_roots": "Muddy Brinetree Roots",
  "block.minecraft.mushroom_stem": "Swamb Stem",
  "block.minecraft.mycelium": "Swambroot",
  "block.minecraft.nether_brick_fence": "Nether Tile Edder",
  "block.minecraft.nether_brick_slab": "Nether Tile Halfclot",
  "block.minecraft.nether_brick_stairs": "Nether Tile Stairs",
  "block.minecraft.nether_brick_wall": "Nether Tile Wall",
  "block.minecraft.nether_bricks": "Nether Tiles",
  "block.minecraft.nether_gold_ore": "Nether Gold Ore",
  "block.minecraft.nether_portal": "Nether Ingang",
  "block.minecraft.nether_quartz_ore": "Nether Hardstone Ore",
  "block.minecraft.nether_sprouts": "Nether Sprouts",
  "block.minecraft.nether_wart": "Nether Wart",
  "block.minecraft.nether_wart_block": "Nether Wart Clot",
  "block.minecraft.netherite_block": "Netherite Clot",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Ringer",
  "block.minecraft.oak_button": "Oak Knap",
  "block.minecraft.oak_door": "Oak Door",
  "block.minecraft.oak_fence": "Oak Edder",
  "block.minecraft.oak_fence_gate": "Oak Edder Gate",
  "block.minecraft.oak_hanging_sign": "Oak Hanging Token",
  "block.minecraft.oak_leaves": "Oak Leaves",
  "block.minecraft.oak_log": "Oak Log",
  "block.minecraft.oak_planks": "Oak Boards",
  "block.minecraft.oak_pressure_plate": "Oak Thrutch Tile",
  "block.minecraft.oak_sapling": "Oak Sapling",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Oak Token",
  "block.minecraft.oak_slab": "Oak Halfclot",
  "block.minecraft.oak_stairs": "Oak Stairs",
  "block.minecraft.oak_trapdoor": "Oak Trapdoor",
  "block.minecraft.oak_wall_hanging_sign": "Oak Wall Hanging Token",
  "block.minecraft.oak_wall_sign": "Oak Wall Token",
  "block.minecraft.oak_wood": "Oak Wood",
  "block.minecraft.observer": "Beholder",
  "block.minecraft.obsidian": "Ravenglass",
  "block.minecraft.ochre_froglight": "Yellow Froglight",
  "block.minecraft.ominous_banner": "Foreboding Fane",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Yellowred Fane",
  "block.minecraft.orange_bed": "Yellowred Bed",
  "block.minecraft.orange_candle": "Yellowred Candle",
  "block.minecraft.orange_candle_cake": "Cake with Yellowred Candle",
  "block.minecraft.orange_carpet": "Yellowred Rug",
  "block.minecraft.orange_concrete": "Yellowred Stonelime",
  "block.minecraft.orange_concrete_powder": "Yellowred Stonelime Dust",
  "block.minecraft.orange_glazed_terracotta": "Yellowred Glazed Redware",
  "block.minecraft.orange_shulker_box": "Yellowred Shulker Box",
  "block.minecraft.orange_stained_glass": "Yellowred Hued Glass",
  "block.minecraft.orange_stained_glass_pane": "Yellowred Hued Glass Sheet",
  "block.minecraft.orange_terracotta": "Yellowred Redware",
  "block.minecraft.orange_tulip": "Yellowred Hovebloom",
  "block.minecraft.orange_wool": "Yellowred Wool",
  "block.minecraft.oxeye_daisy": "White Bothen",
  "block.minecraft.oxidized_chiseled_copper": "Sourshafted Graven Copper",
  "block.minecraft.oxidized_copper": "Sourshafted Copper",
  "block.minecraft.oxidized_copper_bars": "Sourshafted Copper Rods",
  "block.minecraft.oxidized_copper_bulb": "Sourshafted Copper Lightvat",
  "block.minecraft.oxidized_copper_chain": "Sourshafted Copper Rackent",
  "block.minecraft.oxidized_copper_chest": "Sourshafted Copper Chest",
  "block.minecraft.oxidized_copper_door": "Sourshafted Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Sourshafted Coppergolem Graft",
  "block.minecraft.oxidized_copper_grate": "Sourshafted Copper Hurdle",
  "block.minecraft.oxidized_copper_lantern": "Sourshafted Copper Bloakern",
  "block.minecraft.oxidized_copper_trapdoor": "Sourshafted Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "Sourshafted Cut Copper",
  "block.minecraft.oxidized_cut_copper_slab": "Sourshafted Cut Copper Halfclot",
  "block.minecraft.oxidized_cut_copper_stairs": "Sourshafted Cut Copper Stairs",
  "block.minecraft.oxidized_lightning_rod": "Sourshafted Lightning Rod",
  "block.minecraft.packed_ice": "Packed Ice",
  "block.minecraft.packed_mud": "Packed Mud",
  "block.minecraft.pale_hanging_moss": "Bleak Hanging Moss",
  "block.minecraft.pale_moss_block": "Bleak Moss Clot",
  "block.minecraft.pale_moss_carpet": "Bleak Moss Rug",
  "block.minecraft.pale_oak_button": "Bleak Oak Knap",
  "block.minecraft.pale_oak_door": "Bleak Oak Door",
  "block.minecraft.pale_oak_fence": "Bleak Oak Edder",
  "block.minecraft.pale_oak_fence_gate": "Bleak Oak Edder Gate",
  "block.minecraft.pale_oak_hanging_sign": "Bleak Oak Hanging Token",
  "block.minecraft.pale_oak_leaves": "Bleak Oak Leaves",
  "block.minecraft.pale_oak_log": "Bleak Oak Log",
  "block.minecraft.pale_oak_planks": "Bleak Oak Boards",
  "block.minecraft.pale_oak_pressure_plate": "Bleak Oak Thrutch Tile",
  "block.minecraft.pale_oak_sapling": "Bleak Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Bleak Oak Shelf",
  "block.minecraft.pale_oak_sign": "Bleak Oak Token",
  "block.minecraft.pale_oak_slab": "Bleak Oak Halfclot",
  "block.minecraft.pale_oak_stairs": "Bleak Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Bleak Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Bleak Oak Wall Hanging Token",
  "block.minecraft.pale_oak_wall_sign": "Bleak Oak Wall Token",
  "block.minecraft.pale_oak_wood": "Bleak Oak Wood",
  "block.minecraft.pearlescent_froglight": "White Froglight",
  "block.minecraft.peony": "Kingsbloom",
  "block.minecraft.petrified_oak_slab": "Stonened Oak Halfclot",
  "block.minecraft.piglin_head": "Piglin Head",
  "block.minecraft.piglin_wall_head": "Piglin Wall Head",
  "block.minecraft.pink_banner": "Bleak Red Fane",
  "block.minecraft.pink_bed": "Bleak Red Bed",
  "block.minecraft.pink_candle": "Bleak Red Candle",
  "block.minecraft.pink_candle_cake": "Cake with Bleak Red Candle",
  "block.minecraft.pink_carpet": "Bleak Red Rug",
  "block.minecraft.pink_concrete": "Bleak Red Stonelime",
  "block.minecraft.pink_concrete_powder": "Bleak Red Stonelime Dust",
  "block.minecraft.pink_glazed_terracotta": "Bleak Red Glazed Redware",
  "block.minecraft.pink_petals": "Bleak Red Leaves",
  "block.minecraft.pink_shulker_box": "Bleak Red Shulker Box",
  "block.minecraft.pink_stained_glass": "Bleak Red Hued Glass",
  "block.minecraft.pink_stained_glass_pane": "Bleak Red Hued Glass Sheet",
  "block.minecraft.pink_terracotta": "Bleak Red Redware",
  "block.minecraft.pink_tulip": "Bleak Red Hovebloom",
  "block.minecraft.pink_wool": "Bleak Red Wool",
  "block.minecraft.piston": "Sucker",
  "block.minecraft.piston_head": "Sucker Head",
  "block.minecraft.pitcher_crop": "Boukwort Crop",
  "block.minecraft.pitcher_plant": "Boukwort",
  "block.minecraft.player_head": "Player Head",
  "block.minecraft.player_head.named": "%s's Head",
  "block.minecraft.player_wall_head": "Player Wall Head",
  "block.minecraft.podzol": "Underash",
  "block.minecraft.pointed_dripstone": "Orded Dripstone",
  "block.minecraft.polished_andesite": "Sliked Andestone",
  "block.minecraft.polished_andesite_slab": "Sliked Andestone Halfclot",
  "block.minecraft.polished_andesite_stairs": "Sliked Andestone Stairs",
  "block.minecraft.polished_basalt": "Sliked Rinestone",
  "block.minecraft.polished_blackstone": "Sliked Blackstone",
  "block.minecraft.polished_blackstone_brick_slab": "Sliked Blackstone Wallstone Halfclot",
  "block.minecraft.polished_blackstone_brick_stairs": "Sliked Blackstone Wallstone Stairs",
  "block.minecraft.polished_blackstone_brick_wall": "Sliked Blackstone Wallstone Wall",
  "block.minecraft.polished_blackstone_bricks": "Sliked Blackstone Wallstones",
  "block.minecraft.polished_blackstone_button": "Sliked Blackstone Knap",
  "block.minecraft.polished_blackstone_pressure_plate": "Sliked Blackstone Thrutch Tile",
  "block.minecraft.polished_blackstone_slab": "Sliked Blackstone Halfclot",
  "block.minecraft.polished_blackstone_stairs": "Sliked Blackstone Stairs",
  "block.minecraft.polished_blackstone_wall": "Sliked Blackstone Wall",
  "block.minecraft.polished_deepslate": "Sliked Deepstone",
  "block.minecraft.polished_deepslate_slab": "Sliked Deepstone Halfclot",
  "block.minecraft.polished_deepslate_stairs": "Sliked Deepstone Stairs",
  "block.minecraft.polished_deepslate_wall": "Sliked Deepstone Wall",
  "block.minecraft.polished_diorite": "Sliked Shedstone",
  "block.minecraft.polished_diorite_slab": "Sliked Shedstone Halfclot",
  "block.minecraft.polished_diorite_stairs": "Sliked Shedstone Stairs",
  "block.minecraft.polished_granite": "Sliked Cornstone",
  "block.minecraft.polished_granite_slab": "Sliked Cornstone Halfclot",
  "block.minecraft.polished_granite_stairs": "Sliked Cornstone Stairs",
  "block.minecraft.polished_tuff": "Sliked Ashstone",
  "block.minecraft.polished_tuff_slab": "Sliked Ashstone Halfclot",
  "block.minecraft.polished_tuff_stairs": "Sliked Ashstone Stairs",
  "block.minecraft.polished_tuff_wall": "Sliked Ashstone Wall",
  "block.minecraft.poppy": "Poppy",
  "block.minecraft.potatoes": "Earthapples",
  "block.minecraft.potted_acacia_sapling": "Potted Wattle Sapling",
  "block.minecraft.potted_allium": "Potted Entleek",
  "block.minecraft.potted_azalea_bush": "Potted Drywort",
  "block.minecraft.potted_azure_bluet": "Potted Hewnling",
  "block.minecraft.potted_bamboo": "Potted Treereed",
  "block.minecraft.potted_birch_sapling": "Potted Birch Sapling",
  "block.minecraft.potted_blue_orchid": "Potted Bloe Ballockwort",
  "block.minecraft.potted_brown_mushroom": "Potted Brown Swamb",
  "block.minecraft.potted_cactus": "Potted Thorntree",
  "block.minecraft.potted_cherry_sapling": "Potted Chirse Sapling",
  "block.minecraft.potted_closed_eyeblossom": "Potted Shut Eyeblossom",
  "block.minecraft.potted_cornflower": "Potted Cornbloom",
  "block.minecraft.potted_crimson_fungus": "Potted Baze Swamb",
  "block.minecraft.potted_crimson_roots": "Potted Baze Roots",
  "block.minecraft.potted_dandelion": "Potted Monkshead",
  "block.minecraft.potted_dark_oak_sapling": "Potted Dark Oak Sapling",
  "block.minecraft.potted_dead_bush": "Potted Dead Bush",
  "block.minecraft.potted_fern": "Potted Fern",
  "block.minecraft.potted_flowering_azalea_bush": "Potted Blooming Drywort",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Monkshead",
  "block.minecraft.potted_jungle_sapling": "Potted Rainwold Sapling",
  "block.minecraft.potted_lily_of_the_valley": "Potted Glovewort",
  "block.minecraft.potted_mangrove_propagule": "Potted Brinetree Spreadstem",
  "block.minecraft.potted_oak_sapling": "Potted Oak Sapling",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Potted Yellowred Hovebloom",
  "block.minecraft.potted_oxeye_daisy": "Potted White Bothen",
  "block.minecraft.potted_pale_oak_sapling": "Potted Bleak Oak Sapling",
  "block.minecraft.potted_pink_tulip": "Potted Bleak Red Hovebloom",
  "block.minecraft.potted_poppy": "Potted Poppy",
  "block.minecraft.potted_red_mushroom": "Potted Red Swamb",
  "block.minecraft.potted_red_tulip": "Potted Red Hovebloom",
  "block.minecraft.potted_spruce_sapling": "Potted Furrow Sapling",
  "block.minecraft.potted_torchflower": "Potted Brandblossom",
  "block.minecraft.potted_warped_fungus": "Potted Warped Swamb",
  "block.minecraft.potted_warped_roots": "Potted Warped Roots",
  "block.minecraft.potted_white_tulip": "Potted White Hovebloom",
  "block.minecraft.potted_wither_rose": "Potted Wither Roose",
  "block.minecraft.powder_snow": "Dust Snow",
  "block.minecraft.powder_snow_cauldron": "Dust Snow Ironcrock",
  "block.minecraft.powered_rail": "Mightened Ironroad",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Prismarine Wallstone Halfclot",
  "block.minecraft.prismarine_brick_stairs": "Prismarine Wallstone Stairs",
  "block.minecraft.prismarine_bricks": "Prismarine Wallstones",
  "block.minecraft.prismarine_slab": "Prismarine Halfclot",
  "block.minecraft.prismarine_stairs": "Prismarine Stairs",
  "block.minecraft.prismarine_wall": "Prismarine Wall",
  "block.minecraft.pumpkin": "Harvestovet",
  "block.minecraft.pumpkin_stem": "Harvestovet Stem",
  "block.minecraft.purple_banner": "Purple Fane",
  "block.minecraft.purple_bed": "Purple Bed",
  "block.minecraft.purple_candle": "Purple Candle",
  "block.minecraft.purple_candle_cake": "Cake with Purple Candle",
  "block.minecraft.purple_carpet": "Purple Rug",
  "block.minecraft.purple_concrete": "Purple Stonelime",
  "block.minecraft.purple_concrete_powder": "Purple Stonelime Dust",
  "block.minecraft.purple_glazed_terracotta": "Purple Glazed Redware",
  "block.minecraft.purple_shulker_box": "Purple Shulker Box",
  "block.minecraft.purple_stained_glass": "Purple Hued Glass",
  "block.minecraft.purple_stained_glass_pane": "Purple Hued Glass Sheet",
  "block.minecraft.purple_terracotta": "Purple Redware",
  "block.minecraft.purple_wool": "Purple Wool",
  "block.minecraft.purpur_block": "Purpur Clot",
  "block.minecraft.purpur_pillar": "Purpur Staple",
  "block.minecraft.purpur_slab": "Purpur Halfclot",
  "block.minecraft.purpur_stairs": "Purpur Stairs",
  "block.minecraft.quartz_block": "Hardstone Clot",
  "block.minecraft.quartz_bricks": "Hardstone Wallstones",
  "block.minecraft.quartz_pillar": "Hardstone Staple",
  "block.minecraft.quartz_slab": "Hardstone Halfclot",
  "block.minecraft.quartz_stairs": "Hardstone Stairs",
  "block.minecraft.rail": "Ironroad",
  "block.minecraft.raw_copper_block": "Raw Copper Clot",
  "block.minecraft.raw_gold_block": "Raw Gold Clot",
  "block.minecraft.raw_iron_block": "Raw Iron Clot",
  "block.minecraft.red_banner": "Red Fane",
  "block.minecraft.red_bed": "Red Bed",
  "block.minecraft.red_candle": "Red Candle",
  "block.minecraft.red_candle_cake": "Cake with Red Candle",
  "block.minecraft.red_carpet": "Red Rug",
  "block.minecraft.red_concrete": "Red Stonelime",
  "block.minecraft.red_concrete_powder": "Red Stonelime Dust",
  "block.minecraft.red_glazed_terracotta": "Red Glazed Redware",
  "block.minecraft.red_mushroom": "Red Swamb",
  "block.minecraft.red_mushroom_block": "Red Swamb Clot",
  "block.minecraft.red_nether_brick_slab": "Red Nether Tile Halfclot",
  "block.minecraft.red_nether_brick_stairs": "Red Nether Tile Stairs",
  "block.minecraft.red_nether_brick_wall": "Red Nether Tile Wall",
  "block.minecraft.red_nether_bricks": "Red Nether Tiles",
  "block.minecraft.red_sand": "Red Sand",
  "block.minecraft.red_sandstone": "Red Sandstone",
  "block.minecraft.red_sandstone_slab": "Red Sandstone Halfclot",
  "block.minecraft.red_sandstone_stairs": "Red Sandstone Stairs",
  "block.minecraft.red_sandstone_wall": "Red Sandstone Wall",
  "block.minecraft.red_shulker_box": "Red Shulker Box",
  "block.minecraft.red_stained_glass": "Red Hued Glass",
  "block.minecraft.red_stained_glass_pane": "Red Hued Glass Sheet",
  "block.minecraft.red_terracotta": "Red Redware",
  "block.minecraft.red_tulip": "Red Hovebloom",
  "block.minecraft.red_wool": "Red Wool",
  "block.minecraft.redstone_block": "Redstone Clot",
  "block.minecraft.redstone_lamp": "Redstone Lightvat",
  "block.minecraft.redstone_ore": "Redstone Ore",
  "block.minecraft.redstone_torch": "Redstone Brand",
  "block.minecraft.redstone_wall_torch": "Redstone Wall Brand",
  "block.minecraft.redstone_wire": "Redstone Wire",
  "block.minecraft.reinforced_deepslate": "Strengthened Deepstone",
  "block.minecraft.repeater": "Redstone Efter",
  "block.minecraft.repeating_command_block": "Efting Hest Clot",
  "block.minecraft.resin_block": "Glar Clot",
  "block.minecraft.resin_brick_slab": "Glar Tile Halfclot",
  "block.minecraft.resin_brick_stairs": "Glar Tile Stairs",
  "block.minecraft.resin_brick_wall": "Glar Tile Wall",
  "block.minecraft.resin_bricks": "Glar Tiles",
  "block.minecraft.resin_clump": "Glar Clump",
  "block.minecraft.respawn_anchor": "Edstart Holder",
  "block.minecraft.rooted_dirt": "Rooted Dirt",
  "block.minecraft.rose_bush": "Roose Bush",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandstone",
  "block.minecraft.sandstone_slab": "Sandstone Halfclot",
  "block.minecraft.sandstone_stairs": "Sandstone Stairs",
  "block.minecraft.sandstone_wall": "Sandstone Wall",
  "block.minecraft.scaffolding": "Stelling",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk Driver",
  "block.minecraft.sculk_sensor": "Sculk Feeler",
  "block.minecraft.sculk_shrieker": "Sculk Shrieker",
  "block.minecraft.sculk_vein": "Sculk Edder",
  "block.minecraft.sea_lantern": "Sea Lightvat",
  "block.minecraft.sea_pickle": "Sea Pod",
  "block.minecraft.seagrass": "Seagrass",
  "block.minecraft.set_spawn": "Edstarting ord set",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "Swamblight",
  "block.minecraft.shulker_box": "Shulker Box",
  "block.minecraft.skeleton_skull": "Boneframe Skull",
  "block.minecraft.skeleton_wall_skull": "Boneframe Wall Skull",
  "block.minecraft.slime_block": "Slime Clot",
  "block.minecraft.small_amethyst_bud": "Small Drunklack Sprout",
  "block.minecraft.small_dripleaf": "Small Dripleaf",
  "block.minecraft.smithing_table": "Smithing Bench",
  "block.minecraft.smoker": "Smoker",
  "block.minecraft.smooth_basalt": "Smooth Rinestone",
  "block.minecraft.smooth_quartz": "Smooth Hardstone Clot",
  "block.minecraft.smooth_quartz_slab": "Smooth Hardstone Halfclot",
  "block.minecraft.smooth_quartz_stairs": "Smooth Hardstone Stairs",
  "block.minecraft.smooth_red_sandstone": "Smooth Red Sandstone",
  "block.minecraft.smooth_red_sandstone_slab": "Smooth Red Sandstone Halfclot",
  "block.minecraft.smooth_red_sandstone_stairs": "Smooth Red Sandstone Stairs",
  "block.minecraft.smooth_sandstone": "Smooth Sandstone",
  "block.minecraft.smooth_sandstone_slab": "Smooth Sandstone Halfclot",
  "block.minecraft.smooth_sandstone_stairs": "Smooth Sandstone Stairs",
  "block.minecraft.smooth_stone": "Smooth Stone",
  "block.minecraft.smooth_stone_slab": "Smooth Stone Halfclot",
  "block.minecraft.sniffer_egg": "Sniffer Egg",
  "block.minecraft.snow": "Snow",
  "block.minecraft.snow_block": "Snow Clot",
  "block.minecraft.soul_campfire": "Soul Bonfire",
  "block.minecraft.soul_fire": "Soul Fire",
  "block.minecraft.soul_lantern": "Soul Bloakern",
  "block.minecraft.soul_sand": "Soul Sand",
  "block.minecraft.soul_soil": "Soul Dirt",
  "block.minecraft.soul_torch": "Soul Brand",
  "block.minecraft.soul_wall_torch": "Soul Wall Brand",
  "block.minecraft.spawn.not_valid": "You have no home bed or loaded edstart holder, or it was hindered",
  "block.minecraft.spawner": "Warry Begetter",
  "block.minecraft.spawner.desc1": "Brooking Making Egg:",
  "block.minecraft.spawner.desc2": "Sets Wight Kind",
  "block.minecraft.sponge": "Seaswamb",
  "block.minecraft.spore_blossom": "Seed Blossom",
  "block.minecraft.spruce_button": "Furrow Knap",
  "block.minecraft.spruce_door": "Furrow Door",
  "block.minecraft.spruce_fence": "Furrow Edder",
  "block.minecraft.spruce_fence_gate": "Furrow Edder Gate",
  "block.minecraft.spruce_hanging_sign": "Furrow Hanging Token",
  "block.minecraft.spruce_leaves": "Furrow Leaves",
  "block.minecraft.spruce_log": "Furrow Log",
  "block.minecraft.spruce_planks": "Furrow Boards",
  "block.minecraft.spruce_pressure_plate": "Furrow Thrutch Tile",
  "block.minecraft.spruce_sapling": "Furrow Sapling",
  "block.minecraft.spruce_shelf": "Furrow Shelf",
  "block.minecraft.spruce_sign": "Furrow Token",
  "block.minecraft.spruce_slab": "Furrow Halfclot",
  "block.minecraft.spruce_stairs": "Furrow Stairs",
  "block.minecraft.spruce_trapdoor": "Furrow Trapdoor",
  "block.minecraft.spruce_wall_hanging_sign": "Furrow Wall Hanging Token",
  "block.minecraft.spruce_wall_sign": "Furrow Wall Token",
  "block.minecraft.spruce_wood": "Furrow Wood",
  "block.minecraft.sticky_piston": "Sticky Sucker",
  "block.minecraft.stone": "Stone",
  "block.minecraft.stone_brick_slab": "Stone Wallstone Halfclot",
  "block.minecraft.stone_brick_stairs": "Stone Wallstone Stairs",
  "block.minecraft.stone_brick_wall": "Stone Wallstone Wall",
  "block.minecraft.stone_bricks": "Stone Wallstones",
  "block.minecraft.stone_button": "Stone Knap",
  "block.minecraft.stone_pressure_plate": "Stone Thrutch Tile",
  "block.minecraft.stone_slab": "Stone Halfclot",
  "block.minecraft.stone_stairs": "Stone Stairs",
  "block.minecraft.stonecutter": "Stonecutter",
  "block.minecraft.stripped_acacia_log": "Stripped Wattle Log",
  "block.minecraft.stripped_acacia_wood": "Stripped Wattle Wood",
  "block.minecraft.stripped_bamboo_block": "Stripped Treereed Clot",
  "block.minecraft.stripped_birch_log": "Stripped Birch Log",
  "block.minecraft.stripped_birch_wood": "Stripped Birch Wood",
  "block.minecraft.stripped_cherry_log": "Stripped Chirse Log",
  "block.minecraft.stripped_cherry_wood": "Stripped Chirse Wood",
  "block.minecraft.stripped_crimson_hyphae": "Stripped Baze Swambwire",
  "block.minecraft.stripped_crimson_stem": "Stripped Baze Stem",
  "block.minecraft.stripped_dark_oak_log": "Stripped Dark Oak Log",
  "block.minecraft.stripped_dark_oak_wood": "Stripped Dark Oak Wood",
  "block.minecraft.stripped_jungle_log": "Stripped Rainwold Log",
  "block.minecraft.stripped_jungle_wood": "Stripped Rainwold Wood",
  "block.minecraft.stripped_mangrove_log": "Stripped Brinetree Log",
  "block.minecraft.stripped_mangrove_wood": "Stripped Brinetree Wood",
  "block.minecraft.stripped_oak_log": "Stripped Oak Log",
  "block.minecraft.stripped_oak_wood": "Stripped Oak Wood",
  "block.minecraft.stripped_pale_oak_log": "Stripped Bleak Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Bleak Oak Wood",
  "block.minecraft.stripped_spruce_log": "Stripped Furrow Log",
  "block.minecraft.stripped_spruce_wood": "Stripped Furrow Wood",
  "block.minecraft.stripped_warped_hyphae": "Stripped Warped Swambwire",
  "block.minecraft.stripped_warped_stem": "Stripped Warped Stem",
  "block.minecraft.structure_block": "Framework Clot",
  "block.minecraft.structure_void": "Framework Roomth",
  "block.minecraft.sugar_cane": "Sweetreed",
  "block.minecraft.sunflower": "Sunblossom",
  "block.minecraft.suspicious_gravel": "Weird Chisel",
  "block.minecraft.suspicious_sand": "Weird Sand",
  "block.minecraft.sweet_berry_bush": "Sweet Berry Bush",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Tall Grass",
  "block.minecraft.tall_seagrass": "Tall Seagrass",
  "block.minecraft.target": "Markle",
  "block.minecraft.terracotta": "Redware",
  "block.minecraft.test_block": "Fand Clot",
  "block.minecraft.test_instance_block": "Fand Befalling Clot",
  "block.minecraft.tinted_glass": "Shaded Glass",
  "block.minecraft.tnt": "Blastle",
  "block.minecraft.tnt.disabled": "Blastle blasts are laid off",
  "block.minecraft.torch": "Brand",
  "block.minecraft.torchflower": "Brandblossom",
  "block.minecraft.torchflower_crop": "Brandblossom Crop",
  "block.minecraft.trapped_chest": "Trapped Chest",
  "block.minecraft.trial_spawner": "Fand Begetter",
  "block.minecraft.tripwire": "Trapwire",
  "block.minecraft.tripwire_hook": "Trapwire Hook",
  "block.minecraft.tube_coral": "Theet Blossomdeer",
  "block.minecraft.tube_coral_block": "Theet Blossomdeer Clot",
  "block.minecraft.tube_coral_fan": "Theet Blossomdeer Blower",
  "block.minecraft.tube_coral_wall_fan": "Theet Blossomdeer Wall Blower",
  "block.minecraft.tuff": "Ashstone",
  "block.minecraft.tuff_brick_slab": "Ashstone Wallstone Halfclot",
  "block.minecraft.tuff_brick_stairs": "Ashstone Wallstone Stairs",
  "block.minecraft.tuff_brick_wall": "Ashstone Wallstone Wall",
  "block.minecraft.tuff_bricks": "Ashstone Wallstones",
  "block.minecraft.tuff_slab": "Ashstone Halfclot",
  "block.minecraft.tuff_stairs": "Ashstone Stairs",
  "block.minecraft.tuff_wall": "Ashstone Wall",
  "block.minecraft.turtle_egg": "Birdling Egg",
  "block.minecraft.twisting_vines": "Twisting Winetrees",
  "block.minecraft.twisting_vines_plant": "Twisting Winetrees Wort",
  "block.minecraft.vault": "Lockvat",
  "block.minecraft.verdant_froglight": "Green Froglight",
  "block.minecraft.vine": "Winetrees",
  "block.minecraft.void_air": "Empty Lift",
  "block.minecraft.wall_torch": "Wall Brand",
  "block.minecraft.warped_button": "Warped Knap",
  "block.minecraft.warped_door": "Warped Door",
  "block.minecraft.warped_fence": "Warped Edder",
  "block.minecraft.warped_fence_gate": "Warped Edder Gate",
  "block.minecraft.warped_fungus": "Warped Swamb",
  "block.minecraft.warped_hanging_sign": "Warped Hanging Token",
  "block.minecraft.warped_hyphae": "Warped Swambwire",
  "block.minecraft.warped_nylium": "Warped Swambmerthe",
  "block.minecraft.warped_planks": "Warped Boards",
  "block.minecraft.warped_pressure_plate": "Warped Thrutch Tile",
  "block.minecraft.warped_roots": "Warped Roots",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Warped Token",
  "block.minecraft.warped_slab": "Warped Halfclot",
  "block.minecraft.warped_stairs": "Warped Stairs",
  "block.minecraft.warped_stem": "Warped Stem",
  "block.minecraft.warped_trapdoor": "Warped Trapdoor",
  "block.minecraft.warped_wall_hanging_sign": "Warped Wall Hanging Token",
  "block.minecraft.warped_wall_sign": "Warped Wall Token",
  "block.minecraft.warped_wart_block": "Warped Wart Clot",
  "block.minecraft.water": "Water",
  "block.minecraft.water_cauldron": "Water Ironcrock",
  "block.minecraft.waxed_chiseled_copper": "Waxed Graven Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Rods",
  "block.minecraft.waxed_copper_block": "Waxed Copper Clot",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Lightvat",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Rackent",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Waxed Copper Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Coppergolem Graft",
  "block.minecraft.waxed_copper_grate": "Waxed Copper Hurdle",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Bloakern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "Waxed Cut Copper",
  "block.minecraft.waxed_cut_copper_slab": "Waxed Cut Copper Halfclot",
  "block.minecraft.waxed_cut_copper_stairs": "Waxed Cut Copper Stairs",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Unwried Graven Copper",
  "block.minecraft.waxed_exposed_copper": "Waxed Unwried Copper",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Unwried Copper Rods",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Unwried Copper Lightvat",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Unwried Copper Rackent",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Unwried Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Unwried Copper Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Unwried Coppergolem Graft",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Unwried Copper Hurdle",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Unwried Copper Bloakern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Unwried Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "Waxed Unwried Cut Copper",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Waxed Unwried Cut Copper Halfclot",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Waxed Unwried Cut Copper Stairs",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Unwried Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Sourshafted Graven Copper",
  "block.minecraft.waxed_oxidized_copper": "Waxed Sourshafted Copper",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Sourshafted Copper Rods",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Sourshafted Copper Lightvat",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Sourshafted Copper Rackent",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Sourshafted Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Sourshafted Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Sourshafted Coppergolem Graft",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Sourshafted Copper Hurdle",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Sourshafted Copper Bloakern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Sourshafted Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "Waxed Sourshafted Cut Copper",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Waxed Sourshafted Cut Copper Halfclot",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Waxed Sourshafted Cut Copper Stairs",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Sourshafted Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Graven Copper",
  "block.minecraft.waxed_weathered_copper": "Waxed Weathered Copper",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Rods",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Lightvat",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Rackent",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Coppergolem Graft",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Hurdle",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Bloakern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "Waxed Weathered Cut Copper",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Waxed Weathered Cut Copper Halfclot",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Waxed Weathered Cut Copper Stairs",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Graven Copper",
  "block.minecraft.weathered_copper": "Weathered Copper",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Rods",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Lightvat",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Rackent",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Coppergolem Graft",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Hurdle",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Bloakern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "Weathered Cut Copper",
  "block.minecraft.weathered_cut_copper_slab": "Weathered Cut Copper Halfclot",
  "block.minecraft.weathered_cut_copper_stairs": "Weathered Cut Copper Stairs",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Weeping Winetrees",
  "block.minecraft.weeping_vines_plant": "Weeping Winetrees Wort",
  "block.minecraft.wet_sponge": "Wet Seaswamb",
  "block.minecraft.wheat": "Wheat Crops",
  "block.minecraft.white_banner": "White Fane",
  "block.minecraft.white_bed": "White Bed",
  "block.minecraft.white_candle": "White Candle",
  "block.minecraft.white_candle_cake": "Cake with White Candle",
  "block.minecraft.white_carpet": "White Rug",
  "block.minecraft.white_concrete": "White Stonelime",
  "block.minecraft.white_concrete_powder": "White Stonelime Dust",
  "block.minecraft.white_glazed_terracotta": "White Glazed Redware",
  "block.minecraft.white_shulker_box": "White Shulker Box",
  "block.minecraft.white_stained_glass": "White Hued Glass",
  "block.minecraft.white_stained_glass_pane": "White Hued Glass Sheet",
  "block.minecraft.white_terracotta": "White Redware",
  "block.minecraft.white_tulip": "White Hovebloom",
  "block.minecraft.white_wool": "White Wool",
  "block.minecraft.wildflowers": "Wildblossoms",
  "block.minecraft.wither_rose": "Wither Roose",
  "block.minecraft.wither_skeleton_skull": "Wither Boneframe Skull",
  "block.minecraft.wither_skeleton_wall_skull": "Wither Boneframe Wall Skull",
  "block.minecraft.yellow_banner": "Yellow Fane",
  "block.minecraft.yellow_bed": "Yellow Bed",
  "block.minecraft.yellow_candle": "Yellow Candle",
  "block.minecraft.yellow_candle_cake": "Cake with Yellow Candle",
  "block.minecraft.yellow_carpet": "Yellow Rug",
  "block.minecraft.yellow_concrete": "Yellow Stonelime",
  "block.minecraft.yellow_concrete_powder": "Yellow Stonelime Dust",
  "block.minecraft.yellow_glazed_terracotta": "Yellow Glazed Redware",
  "block.minecraft.yellow_shulker_box": "Yellow Shulker Box",
  "block.minecraft.yellow_stained_glass": "Yellow Hued Glass",
  "block.minecraft.yellow_stained_glass_pane": "Yellow Hued Glass Sheet",
  "block.minecraft.yellow_terracotta": "Yellow Redware",
  "block.minecraft.yellow_wool": "Yellow Wool",
  "block.minecraft.zombie_head": "Lich Head",
  "block.minecraft.zombie_wall_head": "Lich Wall Head",
  "item.minecraft.acacia_boat": "Wattle Boat",
  "item.minecraft.acacia_chest_boat": "Wattle Boat with Chest",
  "item.minecraft.allay_spawn_egg": "Allay Making Egg",
  "item.minecraft.amethyst_shard": "Drunklack Shard",
  "item.minecraft.angler_pottery_shard": "Fisherman Pot Shard",
  "item.minecraft.angler_pottery_sherd": "Fisherman Potsherd",
  "item.minecraft.apple": "Apple",
  "item.minecraft.archer_pottery_shard": "Bowman Pot Shard",
  "item.minecraft.archer_pottery_sherd": "Bowman Potsherd",
  "item.minecraft.armadillo_scute": "Girdledeer Shale",
  "item.minecraft.armadillo_spawn_egg": "Girdledeer Making Egg",
  "item.minecraft.armor_stand": "Borrow Stand",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pot Shard",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up Potsherd",
  "item.minecraft.arrow": "Arrow",
  "item.minecraft.axolotl_bucket": "Stop of Waterhelper",
  "item.minecraft.axolotl_spawn_egg": "Waterhelper Making Egg",
  "item.minecraft.baked_potato": "Baked Earthapple",
  "item.minecraft.bamboo_chest_raft": "Treereed Float with Chest",
  "item.minecraft.bamboo_raft": "Treereed Float",
  "item.minecraft.bat_spawn_egg": "Bat Making Egg",
  "item.minecraft.bee_spawn_egg": "Bee Making Egg",
  "item.minecraft.beef": "Raw Cowflesh",
  "item.minecraft.beetroot": "Beetroot",
  "item.minecraft.beetroot_seeds": "Beetroot Seeds",
  "item.minecraft.beetroot_soup": "Beetroot Broth",
  "item.minecraft.birch_boat": "Birch Boat",
  "item.minecraft.birch_chest_boat": "Birch Boat with Chest",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Black Dye",
  "item.minecraft.black_harness": "Black Read",
  "item.minecraft.blade_pottery_shard": "Blade Pot Shard",
  "item.minecraft.blade_pottery_sherd": "Blade Potsherd",
  "item.minecraft.blaze_powder": "Blaze Dust",
  "item.minecraft.blaze_rod": "Blaze Rod",
  "item.minecraft.blaze_spawn_egg": "Blaze Making Egg",
  "item.minecraft.blue_bundle": "Bloe Bundle",
  "item.minecraft.blue_dye": "Bloe Dye",
  "item.minecraft.blue_egg": "Bloe Egg",
  "item.minecraft.blue_harness": "Bloe Read",
  "item.minecraft.bogged_spawn_egg": "Bogged Making Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Borrow Trim",
  "item.minecraft.bone": "Bone",
  "item.minecraft.bone_meal": "Bonemeal",
  "item.minecraft.book": "Book",
  "item.minecraft.bordure_indented_banner_pattern": "Sawtoothed Frame Fane Twill",
  "item.minecraft.bow": "Bow",
  "item.minecraft.bowl": "Bowl",
  "item.minecraft.bread": "Bread",
  "item.minecraft.breeze_rod": "Whith Rod",
  "item.minecraft.breeze_spawn_egg": "Whith Making Egg",
  "item.minecraft.brewer_pottery_shard": "Brewer Pot Shard",
  "item.minecraft.brewer_pottery_sherd": "Brewer Potsherd",
  "item.minecraft.brewing_stand": "Brewing Stand",
  "item.minecraft.brick": "Tile",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Brown Dye",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Read",
  "item.minecraft.brush": "Bristler",
  "item.minecraft.bucket": "Stop",
  "item.minecraft.bundle": "Bundle",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a minged heap of things",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Burn Pot Shard",
  "item.minecraft.burn_pottery_sherd": "Burn Potsherd",
  "item.minecraft.camel_husk_spawn_egg": "Olvend Husk Making Egg",
  "item.minecraft.camel_spawn_egg": "Olvend Making Egg",
  "item.minecraft.carrot": "Walmore",
  "item.minecraft.carrot_on_a_stick": "Walmore on a Stick",
  "item.minecraft.cat_spawn_egg": "Cat Making Egg",
  "item.minecraft.cauldron": "Ironcrock",
  "item.minecraft.cave_spider_spawn_egg": "Shraff Spider Making Egg",
  "item.minecraft.chainmail_boots": "Ringnet Shoes",
  "item.minecraft.chainmail_chestplate": "Ringnet Breastbor",
  "item.minecraft.chainmail_helmet": "Ringnet Helm",
  "item.minecraft.chainmail_leggings": "Ringnet Leggings",
  "item.minecraft.charcoal": "Charcoal",
  "item.minecraft.cherry_boat": "Chirse Boat",
  "item.minecraft.cherry_chest_boat": "Chirse Boat with Chest",
  "item.minecraft.chest_minecart": "Delvewain with Chest",
  "item.minecraft.chicken": "Raw Chicken",
  "item.minecraft.chicken_spawn_egg": "Chicken Making Egg",
  "item.minecraft.chorus_fruit": "Chorovet",
  "item.minecraft.clay_ball": "Clay Ball",
  "item.minecraft.clock": "Daymeal",
  "item.minecraft.coal": "Coal",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Beach Borrow Trim",
  "item.minecraft.cocoa_beans": "Cocoabeans",
  "item.minecraft.cod": "Raw Cod",
  "item.minecraft.cod_bucket": "Stop of Cod",
  "item.minecraft.cod_spawn_egg": "Cod Making Egg",
  "item.minecraft.command_block_minecart": "Delvewain with Hest Clot",
  "item.minecraft.compass": "Northfinder",
  "item.minecraft.cooked_beef": "Steak",
  "item.minecraft.cooked_chicken": "Cooked Chicken",
  "item.minecraft.cooked_cod": "Cooked Cod",
  "item.minecraft.cooked_mutton": "Cooked Sheep",
  "item.minecraft.cooked_porkchop": "Cooked Pigflesh",
  "item.minecraft.cooked_rabbit": "Cooked Hare",
  "item.minecraft.cooked_salmon": "Cooked Lax",
  "item.minecraft.cookie": "Cookie",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Shoes",
  "item.minecraft.copper_chestplate": "Copper Breastbor",
  "item.minecraft.copper_golem_spawn_egg": "Coppergolem Making Egg",
  "item.minecraft.copper_helmet": "Copper Helm",
  "item.minecraft.copper_hoe": "Copper Tiller",
  "item.minecraft.copper_horse_armor": "Copper Horse Borrow",
  "item.minecraft.copper_ingot": "Copper Ingot",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Shipperfish Borrow",
  "item.minecraft.copper_nugget": "Copper Climper",
  "item.minecraft.copper_pickaxe": "Copper Mattock",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Cow Making Egg",
  "item.minecraft.creaking_spawn_egg": "Creaking Making Egg",
  "item.minecraft.creeper_banner_pattern": "Fane Twill",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper Shape",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Shape Fane Twill",
  "item.minecraft.creeper_spawn_egg": "Creeper Making Egg",
  "item.minecraft.crossbow": "Crossbow",
  "item.minecraft.crossbow.projectile": "Shot:",
  "item.minecraft.crossbow.projectile.multiple": "Shot: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Shot: %s",
  "item.minecraft.cyan_bundle": "Teal Bundle",
  "item.minecraft.cyan_dye": "Teal Dye",
  "item.minecraft.cyan_harness": "Teal Read",
  "item.minecraft.danger_pottery_shard": "Bane Pot Shard",
  "item.minecraft.danger_pottery_sherd": "Bane Potsherd",
  "item.minecraft.dark_oak_boat": "Dark Oak Boat",
  "item.minecraft.dark_oak_chest_boat": "Dark Oak Boat with Chest",
  "item.minecraft.debug_stick": "Unbug Stick",
  "item.minecraft.debug_stick.empty": "%s has no holdings",
  "item.minecraft.debug_stick.select": "chosen \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" to %s",
  "item.minecraft.diamond": "Athamans",
  "item.minecraft.diamond_axe": "Athamans Axe",
  "item.minecraft.diamond_boots": "Athamans Shoes",
  "item.minecraft.diamond_chestplate": "Athamans Breastbor",
  "item.minecraft.diamond_helmet": "Athamans Helm",
  "item.minecraft.diamond_hoe": "Athamans Tiller",
  "item.minecraft.diamond_horse_armor": "Athamans Horse Borrow",
  "item.minecraft.diamond_leggings": "Athamans Leggings",
  "item.minecraft.diamond_nautilus_armor": "Athamans Shipperfish Borrow",
  "item.minecraft.diamond_pickaxe": "Athamans Mattock",
  "item.minecraft.diamond_shovel": "Athamans Shovel",
  "item.minecraft.diamond_spear": "Athamans Spear",
  "item.minecraft.diamond_sword": "Athamans Sword",
  "item.minecraft.disc_fragment_5": "Shive Shard",
  "item.minecraft.disc_fragment_5.desc": "Song Shive - 5",
  "item.minecraft.dolphin_spawn_egg": "Merswine Making Egg",
  "item.minecraft.donkey_spawn_egg": "Easel Making Egg",
  "item.minecraft.dragon_breath": "Drake's Breath",
  "item.minecraft.dried_kelp": "Dried Kelp",
  "item.minecraft.drowned_spawn_egg": "Drenched Making Egg",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Sandhill Borrow Trim",
  "item.minecraft.echo_shard": "Edring Shard",
  "item.minecraft.egg": "Egg",
  "item.minecraft.elder_guardian_spawn_egg": "Elder Keeper Making Egg",
  "item.minecraft.elytra": "Enderglider",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Galed Book",
  "item.minecraft.enchanted_golden_apple": "Galed Golden Apple",
  "item.minecraft.end_crystal": "End Cristle",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Drake Making Egg",
  "item.minecraft.ender_eye": "Eye of Ender",
  "item.minecraft.ender_pearl": "Ender Mergroat",
  "item.minecraft.enderman_spawn_egg": "Enderman Making Egg",
  "item.minecraft.endermite_spawn_egg": "Endermite Making Egg",
  "item.minecraft.evoker_spawn_egg": "Awakener Making Egg",
  "item.minecraft.experience_bottle": "Flash o' Goldering",
  "item.minecraft.explorer_pottery_shard": "Seeker Pot Shard",
  "item.minecraft.explorer_pottery_sherd": "Seeker Potsherd",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Borrow Trim",
  "item.minecraft.feather": "Feather",
  "item.minecraft.fermented_spider_eye": "Quickened Spider Eye",
  "item.minecraft.field_masoned_banner_pattern": "Field Stonewrought Fane Twill",
  "item.minecraft.filled_map": "Draft",
  "item.minecraft.fire_charge": "Fire Blast",
  "item.minecraft.firework_rocket": "Firework",
  "item.minecraft.firework_rocket.flight": "Flight Lastingness:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Firework Star",
  "item.minecraft.firework_star.black": "Black",
  "item.minecraft.firework_star.blue": "Bloe",
  "item.minecraft.firework_star.brown": "Brown",
  "item.minecraft.firework_star.custom_color": "Bespoke",
  "item.minecraft.firework_star.cyan": "Teal",
  "item.minecraft.firework_star.fade_to": "Wane to",
  "item.minecraft.firework_star.flicker": "Twinkle",
  "item.minecraft.firework_star.gray": "Gray",
  "item.minecraft.firework_star.green": "Green",
  "item.minecraft.firework_star.light_blue": "Light Bloe",
  "item.minecraft.firework_star.light_gray": "Light Gray",
  "item.minecraft.firework_star.lime": "Light Green",
  "item.minecraft.firework_star.magenta": "Light Purple",
  "item.minecraft.firework_star.orange": "Yellowred",
  "item.minecraft.firework_star.pink": "Bleak Red",
  "item.minecraft.firework_star.purple": "Purple",
  "item.minecraft.firework_star.red": "Red",
  "item.minecraft.firework_star.shape": "Unknown Shape",
  "item.minecraft.firework_star.shape.burst": "Burst",
  "item.minecraft.firework_star.shape.creeper": "Creeper-shaped",
  "item.minecraft.firework_star.shape.large_ball": "Big Ball",
  "item.minecraft.firework_star.shape.small_ball": "Small Ball",
  "item.minecraft.firework_star.shape.star": "Star-shaped",
  "item.minecraft.firework_star.trail": "Flightpath",
  "item.minecraft.firework_star.white": "White",
  "item.minecraft.firework_star.yellow": "Yellow",
  "item.minecraft.fishing_rod": "Fishing Rod",
  "item.minecraft.flint": "Flint",
  "item.minecraft.flint_and_steel": "Flint and Steel",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Borrow Trim",
  "item.minecraft.flow_banner_pattern": "Fane Twill",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Fane Twill",
  "item.minecraft.flow_pottery_sherd": "Flow Potsherd",
  "item.minecraft.flower_banner_pattern": "Fane Twill",
  "item.minecraft.flower_banner_pattern.desc": "Blossom Shape",
  "item.minecraft.flower_banner_pattern.new": "Blossom Shape Fane Twill",
  "item.minecraft.flower_pot": "Blossom Pot",
  "item.minecraft.fox_spawn_egg": "Fox Making Egg",
  "item.minecraft.friend_pottery_shard": "Friend Pot Shard",
  "item.minecraft.friend_pottery_sherd": "Friend Potsherd",
  "item.minecraft.frog_spawn_egg": "Frog Making Egg",
  "item.minecraft.furnace_minecart": "Delvewain with Kiln",
  "item.minecraft.ghast_spawn_egg": "Ghast Making Egg",
  "item.minecraft.ghast_tear": "Ghast Tear",
  "item.minecraft.glass_bottle": "Glassflash",
  "item.minecraft.glistering_melon_slice": "Glistering Entapple Sliver",
  "item.minecraft.globe_banner_pattern": "Fane Twill",
  "item.minecraft.globe_banner_pattern.desc": "Thother",
  "item.minecraft.globe_banner_pattern.new": "Thother Fane Twill",
  "item.minecraft.glow_berries": "Glow Berries",
  "item.minecraft.glow_ink_sac": "Glow Bleck Sack",
  "item.minecraft.glow_item_frame": "Glow Thing Frame",
  "item.minecraft.glow_squid_spawn_egg": "Glow Sleevefish Making Egg",
  "item.minecraft.glowstone_dust": "Glowstone Dust",
  "item.minecraft.goat_horn": "Goat Horn",
  "item.minecraft.goat_spawn_egg": "Goat Making Egg",
  "item.minecraft.gold_ingot": "Gold Ingot",
  "item.minecraft.gold_nugget": "Gold Climper",
  "item.minecraft.golden_apple": "Golden Apple",
  "item.minecraft.golden_axe": "Golden Axe",
  "item.minecraft.golden_boots": "Golden Shoes",
  "item.minecraft.golden_carrot": "Golden Walmore",
  "item.minecraft.golden_chestplate": "Golden Breastbor",
  "item.minecraft.golden_helmet": "Golden Helm",
  "item.minecraft.golden_hoe": "Golden Tiller",
  "item.minecraft.golden_horse_armor": "Golden Horse Borrow",
  "item.minecraft.golden_leggings": "Golden Leggings",
  "item.minecraft.golden_nautilus_armor": "Golden Shipperfish Borrow",
  "item.minecraft.golden_pickaxe": "Golden Mattock",
  "item.minecraft.golden_shovel": "Golden Shovel",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Golden Sword",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Gray Dye",
  "item.minecraft.gray_harness": "Gray Read",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Green Dye",
  "item.minecraft.green_harness": "Green Read",
  "item.minecraft.guardian_spawn_egg": "Keeper Making Egg",
  "item.minecraft.gunpowder": "Gundust",
  "item.minecraft.guster_banner_pattern": "Fane Twill",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Fane Twill",
  "item.minecraft.guster_pottery_sherd": "Guster Potsherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Making Egg",
  "item.minecraft.harness": "Read",
  "item.minecraft.heart_of_the_sea": "Heart of the Sea",
  "item.minecraft.heart_pottery_shard": "Heart Pot Shard",
  "item.minecraft.heart_pottery_sherd": "Heart Potsherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pot Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Potsherd",
  "item.minecraft.hoglin_spawn_egg": "Hoglin Making Egg",
  "item.minecraft.honey_bottle": "Honey Flash",
  "item.minecraft.honeycomb": "Honeycomb",
  "item.minecraft.hopper_minecart": "Delvewain with Hopper",
  "item.minecraft.horse_spawn_egg": "Horse Making Egg",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.host_armor_trim_smithing_template.new": "Dright Borrow Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pot Shard",
  "item.minecraft.howl_pottery_sherd": "Howl Potsherd",
  "item.minecraft.husk_spawn_egg": "Husk Making Egg",
  "item.minecraft.ink_sac": "Bleck Sack",
  "item.minecraft.iron_axe": "Iron Axe",
  "item.minecraft.iron_boots": "Iron Shoes",
  "item.minecraft.iron_chestplate": "Iron Breastbor",
  "item.minecraft.iron_golem_spawn_egg": "Irongolem Making Egg",
  "item.minecraft.iron_helmet": "Iron Helm",
  "item.minecraft.iron_hoe": "Iron Tiller",
  "item.minecraft.iron_horse_armor": "Iron Horse Borrow",
  "item.minecraft.iron_ingot": "Iron Ingot",
  "item.minecraft.iron_leggings": "Iron Leggings",
  "item.minecraft.iron_nautilus_armor": "Iron Shipperfish Borrow",
  "item.minecraft.iron_nugget": "Iron Climper",
  "item.minecraft.iron_pickaxe": "Iron Mattock",
  "item.minecraft.iron_shovel": "Iron Shovel",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Iron Sword",
  "item.minecraft.item_frame": "Thing Frame",
  "item.minecraft.jungle_boat": "Rainwold Boat",
  "item.minecraft.jungle_chest_boat": "Rainwold Boat with Chest",
  "item.minecraft.knowledge_book": "Knowledge Book",
  "item.minecraft.lapis_lazuli": "Hewnstone",
  "item.minecraft.lava_bucket": "Moltenstone Stop",
  "item.minecraft.lead": "Lead",
  "item.minecraft.leather": "Leather",
  "item.minecraft.leather_boots": "Leather Shoes",
  "item.minecraft.leather_chestplate": "Leather Shirt",
  "item.minecraft.leather_helmet": "Leather Hat",
  "item.minecraft.leather_horse_armor": "Leather Horse Borrow",
  "item.minecraft.leather_leggings": "Leather Breeches",
  "item.minecraft.light_blue_bundle": "Light Bloe Bundle",
  "item.minecraft.light_blue_dye": "Light Bloe Dye",
  "item.minecraft.light_blue_harness": "Light Bloe Read",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Light Gray Dye",
  "item.minecraft.light_gray_harness": "Light Gray Read",
  "item.minecraft.lime_bundle": "Light Green Bundle",
  "item.minecraft.lime_dye": "Light Green Dye",
  "item.minecraft.lime_harness": "Light Green Read",
  "item.minecraft.lingering_potion": "Lingering Lib",
  "item.minecraft.lingering_potion.effect.awkward": "Awkward Lingering Lib",
  "item.minecraft.lingering_potion.effect.empty": "Lingering Uncraftbere Lib",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Lingering Lib of Fire Withstanding",
  "item.minecraft.lingering_potion.effect.harming": "Lingering Lib of Harming",
  "item.minecraft.lingering_potion.effect.healing": "Lingering Lib of Healing",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Lib of Beriding",
  "item.minecraft.lingering_potion.effect.invisibility": "Lingering Lib of Unseenliness",
  "item.minecraft.lingering_potion.effect.leaping": "Lingering Lib of Leaping",
  "item.minecraft.lingering_potion.effect.levitation": "Lingering Lib of Hovering",
  "item.minecraft.lingering_potion.effect.luck": "Lingering Lib of Luck",
  "item.minecraft.lingering_potion.effect.mundane": "Dull Lingering Lib",
  "item.minecraft.lingering_potion.effect.night_vision": "Lingering Lib of Nightsight",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Lib of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Lingering Lib of Atter",
  "item.minecraft.lingering_potion.effect.regeneration": "Lingering Lib of Edhealing",
  "item.minecraft.lingering_potion.effect.slow_falling": "Lingering Lib of Slow Falling",
  "item.minecraft.lingering_potion.effect.slowness": "Lingering Lib of Slowness",
  "item.minecraft.lingering_potion.effect.strength": "Lingering Lib of Strength",
  "item.minecraft.lingering_potion.effect.swiftness": "Lingering Lib of Swiftness",
  "item.minecraft.lingering_potion.effect.thick": "Thick Lingering Lib",
  "item.minecraft.lingering_potion.effect.turtle_master": "Lingering Lib of the Birdling Lord",
  "item.minecraft.lingering_potion.effect.water": "Lingering Water Flash",
  "item.minecraft.lingering_potion.effect.water_breathing": "Lingering Lib of Water Breathing",
  "item.minecraft.lingering_potion.effect.weakness": "Lingering Lib of Weakness",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Lib of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Lib of Wind Loading",
  "item.minecraft.llama_spawn_egg": "Sheepolvend Making Egg",
  "item.minecraft.lodestone_compass": "Lodestone Northfinder",
  "item.minecraft.mace": "Beetle",
  "item.minecraft.magenta_bundle": "Light Purple Bundle",
  "item.minecraft.magenta_dye": "Light Purple Dye",
  "item.minecraft.magenta_harness": "Light Purple Read",
  "item.minecraft.magma_cream": "Moltenstone Ream",
  "item.minecraft.magma_cube_spawn_egg": "Moltenstone Slime Making Egg",
  "item.minecraft.mangrove_boat": "Brinetree Boat",
  "item.minecraft.mangrove_chest_boat": "Brinetree Boat with Chest",
  "item.minecraft.map": "Empty Draft",
  "item.minecraft.melon_seeds": "Entapple Seeds",
  "item.minecraft.melon_slice": "Entapple Sliver",
  "item.minecraft.milk_bucket": "Milk Stop",
  "item.minecraft.minecart": "Delvewain",
  "item.minecraft.miner_pottery_shard": "Delver Pot Shard",
  "item.minecraft.miner_pottery_sherd": "Delver Potsherd",
  "item.minecraft.mojang_banner_pattern": "Fane Twill",
  "item.minecraft.mojang_banner_pattern.desc": "Thing",
  "item.minecraft.mojang_banner_pattern.new": "Thing Fane Twill",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom Making Egg",
  "item.minecraft.mourner_pottery_shard": "Mourner Pot Shard",
  "item.minecraft.mourner_pottery_sherd": "Mourner Potsherd",
  "item.minecraft.mule_spawn_egg": "Mowl Making Egg",
  "item.minecraft.mushroom_stew": "Swamb Broth",
  "item.minecraft.music_disc_11": "Song Shive",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Song Shive",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Song Shive",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Song Shive",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Song Shive",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Song Shive",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Song Shive",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Song Shive",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Swin Box)",
  "item.minecraft.music_disc_far": "Song Shive",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Song Shive",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Song Shive",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Song Shive",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Song Shive",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Song Shive",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Song Shive",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Song Shive",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Song Shive",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Song Shive",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Song Shive",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Song Shive",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Song Shive",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Raw Sheep",
  "item.minecraft.name_tag": "Name Token",
  "item.minecraft.nautilus_shell": "Shipperfish Shell",
  "item.minecraft.nautilus_spawn_egg": "Shipperfish Making Egg",
  "item.minecraft.nether_brick": "Nether Tile",
  "item.minecraft.nether_star": "Nether Star",
  "item.minecraft.nether_wart": "Nether Wart",
  "item.minecraft.netherite_axe": "Netherite Axe",
  "item.minecraft.netherite_boots": "Netherite Shoes",
  "item.minecraft.netherite_chestplate": "Netherite Breastbor",
  "item.minecraft.netherite_helmet": "Netherite Helm",
  "item.minecraft.netherite_hoe": "Netherite Tiller",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Borrow",
  "item.minecraft.netherite_ingot": "Netherite Ingot",
  "item.minecraft.netherite_leggings": "Netherite Leggings",
  "item.minecraft.netherite_nautilus_armor": "Netherite Shipperfish Borrow",
  "item.minecraft.netherite_pickaxe": "Netherite Mattock",
  "item.minecraft.netherite_scrap": "Netherite Shred",
  "item.minecraft.netherite_shovel": "Netherite Shovel",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Netherite Sword",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Forebisen",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Bettering",
  "item.minecraft.oak_boat": "Oak Boat",
  "item.minecraft.oak_chest_boat": "Oak Boat with Chest",
  "item.minecraft.ocelot_spawn_egg": "Bushcat Making Egg",
  "item.minecraft.ominous_bottle": "Foreboding Flash",
  "item.minecraft.ominous_trial_key": "Foreboding Fand Key",
  "item.minecraft.orange_bundle": "Yellowred Bundle",
  "item.minecraft.orange_dye": "Yellowred Dye",
  "item.minecraft.orange_harness": "Yellowred Read",
  "item.minecraft.painting": "Meting",
  "item.minecraft.pale_oak_boat": "Bleak Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Bleak Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "Catbear Making Egg",
  "item.minecraft.paper": "Bookfell",
  "item.minecraft.parched_spawn_egg": "Seared Making Egg",
  "item.minecraft.parrot_spawn_egg": "Bleefowl Making Egg",
  "item.minecraft.phantom_membrane": "Shinelock Hame",
  "item.minecraft.phantom_spawn_egg": "Shinelock Making Egg",
  "item.minecraft.pig_spawn_egg": "Pig Making Egg",
  "item.minecraft.piglin_banner_pattern": "Fane Twill",
  "item.minecraft.piglin_banner_pattern.desc": "Snout",
  "item.minecraft.piglin_banner_pattern.new": "Snout Fane Twill",
  "item.minecraft.piglin_brute_spawn_egg": "Mad Piglin Making Egg",
  "item.minecraft.piglin_spawn_egg": "Piglin Making Egg",
  "item.minecraft.pillager_spawn_egg": "Harrier Making Egg",
  "item.minecraft.pink_bundle": "Bleak Red Bundle",
  "item.minecraft.pink_dye": "Bleak Red Dye",
  "item.minecraft.pink_harness": "Bleak Red Read",
  "item.minecraft.pitcher_plant": "Boukwort",
  "item.minecraft.pitcher_pod": "Boukwort Pod",
  "item.minecraft.plenty_pottery_shard": "Fulth Pot Shard",
  "item.minecraft.plenty_pottery_sherd": "Fulth Potsherd",
  "item.minecraft.poisonous_potato": "Attery Earthapple",
  "item.minecraft.polar_bear_spawn_egg": "Icebear Making Egg",
  "item.minecraft.popped_chorus_fruit": "Popped Chorovet",
  "item.minecraft.porkchop": "Raw Pigflesh",
  "item.minecraft.potato": "Earthapple",
  "item.minecraft.potion": "Lib",
  "item.minecraft.potion.effect.awkward": "Awkward Lib",
  "item.minecraft.potion.effect.empty": "Uncraftbere Lib",
  "item.minecraft.potion.effect.fire_resistance": "Lib of Fire Withstanding",
  "item.minecraft.potion.effect.harming": "Lib of Harming",
  "item.minecraft.potion.effect.healing": "Lib of Healing",
  "item.minecraft.potion.effect.infested": "Lib of Beriding",
  "item.minecraft.potion.effect.invisibility": "Lib of Unseenliness",
  "item.minecraft.potion.effect.leaping": "Lib of Leaping",
  "item.minecraft.potion.effect.levitation": "Lib of Hovering",
  "item.minecraft.potion.effect.luck": "Lib of Luck",
  "item.minecraft.potion.effect.mundane": "Dull Lib",
  "item.minecraft.potion.effect.night_vision": "Lib of Nightsight",
  "item.minecraft.potion.effect.oozing": "Lib of Oozing",
  "item.minecraft.potion.effect.poison": "Lib of Atter",
  "item.minecraft.potion.effect.regeneration": "Lib of Edhealing",
  "item.minecraft.potion.effect.slow_falling": "Lib of Slow Falling",
  "item.minecraft.potion.effect.slowness": "Lib of Slowness",
  "item.minecraft.potion.effect.strength": "Lib of Strength",
  "item.minecraft.potion.effect.swiftness": "Lib of Swiftness",
  "item.minecraft.potion.effect.thick": "Thick Lib",
  "item.minecraft.potion.effect.turtle_master": "Lib of the Birdling Lord",
  "item.minecraft.potion.effect.water": "Water Flash",
  "item.minecraft.potion.effect.water_breathing": "Lib of Water Breathing",
  "item.minecraft.potion.effect.weakness": "Lib of Weakness",
  "item.minecraft.potion.effect.weaving": "Lib of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Lib of Wind Loading",
  "item.minecraft.pottery_shard_archer": "Bowman Pot Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pot Shard",
  "item.minecraft.pottery_shard_prize": "Meed Pot Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pot Shard",
  "item.minecraft.powder_snow_bucket": "Dust Snow Stop",
  "item.minecraft.prismarine_crystals": "Prismarine Cristles",
  "item.minecraft.prismarine_shard": "Prismarine Shard",
  "item.minecraft.prize_pottery_shard": "Meed Pot Shard",
  "item.minecraft.prize_pottery_sherd": "Meed Potsherd",
  "item.minecraft.pufferfish": "Pufferfish",
  "item.minecraft.pufferfish_bucket": "Stop of Pufferfish",
  "item.minecraft.pufferfish_spawn_egg": "Pufferfish Making Egg",
  "item.minecraft.pumpkin_pie": "Harvestovet Bake",
  "item.minecraft.pumpkin_seeds": "Harvestovet Seeds",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Purple Dye",
  "item.minecraft.purple_harness": "Purple Read",
  "item.minecraft.quartz": "Nether Hardstone",
  "item.minecraft.rabbit": "Raw Hare",
  "item.minecraft.rabbit_foot": "Hare's Foot",
  "item.minecraft.rabbit_hide": "Hare Hide",
  "item.minecraft.rabbit_spawn_egg": "Hare Making Egg",
  "item.minecraft.rabbit_stew": "Hare Broth",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Borrow Trim",
  "item.minecraft.ravager_spawn_egg": "Weaster Making Egg",
  "item.minecraft.raw_copper": "Raw Copper",
  "item.minecraft.raw_gold": "Raw Gold",
  "item.minecraft.raw_iron": "Raw Iron",
  "item.minecraft.recovery_compass": "Deathfinder",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Red Dye",
  "item.minecraft.red_harness": "Red Read",
  "item.minecraft.redstone": "Redstone Dust",
  "item.minecraft.resin_brick": "Glar Tile",
  "item.minecraft.resin_clump": "Glar Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Borrow Trim",
  "item.minecraft.rotten_flesh": "Rotten Flesh",
  "item.minecraft.saddle": "Saddle",
  "item.minecraft.salmon": "Raw Lax",
  "item.minecraft.salmon_bucket": "Stop of Lax",
  "item.minecraft.salmon_spawn_egg": "Lax Making Egg",
  "item.minecraft.scrape_pottery_sherd": "Shrape Potsherd",
  "item.minecraft.scute": "Shale",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Watchman Borrow Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Borrow Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pot Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Potsherd",
  "item.minecraft.shears": "Shears",
  "item.minecraft.sheep_spawn_egg": "Sheep Making Egg",
  "item.minecraft.shelter_pottery_shard": "Shelter Pot Shard",
  "item.minecraft.shelter_pottery_sherd": "Shelter Potsherd",
  "item.minecraft.shield": "Shield",
  "item.minecraft.shield.black": "Black Shield",
  "item.minecraft.shield.blue": "Bloe Shield",
  "item.minecraft.shield.brown": "Brown Shield",
  "item.minecraft.shield.cyan": "Teal Shield",
  "item.minecraft.shield.gray": "Gray Shield",
  "item.minecraft.shield.green": "Green Shield",
  "item.minecraft.shield.light_blue": "Light Bloe Shield",
  "item.minecraft.shield.light_gray": "Light Gray Shield",
  "item.minecraft.shield.lime": "Light Green Shield",
  "item.minecraft.shield.magenta": "Light Purple Shield",
  "item.minecraft.shield.orange": "Yellowred Shield",
  "item.minecraft.shield.pink": "Bleak Red Shield",
  "item.minecraft.shield.purple": "Purple Shield",
  "item.minecraft.shield.red": "Red Shield",
  "item.minecraft.shield.white": "White Shield",
  "item.minecraft.shield.yellow": "Yellow Shield",
  "item.minecraft.shulker_shell": "Shulker Shell",
  "item.minecraft.shulker_spawn_egg": "Shulker Making Egg",
  "item.minecraft.sign": "Token",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stillness Borrow Trim",
  "item.minecraft.silverfish_spawn_egg": "Silverfish Making Egg",
  "item.minecraft.skeleton_horse_spawn_egg": "Boneframe Horse Making Egg",
  "item.minecraft.skeleton_spawn_egg": "Boneframe Making Egg",
  "item.minecraft.skull_banner_pattern": "Fane Twill",
  "item.minecraft.skull_banner_pattern.desc": "Skull Shape",
  "item.minecraft.skull_banner_pattern.new": "Skull Shape Fane Twill",
  "item.minecraft.skull_pottery_shard": "Skull Pot Shard",
  "item.minecraft.skull_pottery_sherd": "Skull Potsherd",
  "item.minecraft.slime_ball": "Slimeball",
  "item.minecraft.slime_spawn_egg": "Slime Making Egg",
  "item.minecraft.smithing_template": "Smithing Forebisen",
  "item.minecraft.smithing_template.applies_to": "Beseeches to:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Eke ingot or cristle",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Borrow",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Eke a borrow",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Cristles",
  "item.minecraft.smithing_template.ingredients": "Anworks:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Eke Netherite Ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Athamans Hardware",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Eke athamans borrow, weapon or tool",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "Bettering: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer Making Egg",
  "item.minecraft.snort_pottery_shard": "Sniff Pot Shard",
  "item.minecraft.snort_pottery_sherd": "Sniff Potsherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Borrow Trim",
  "item.minecraft.snow_golem_spawn_egg": "Snowman Making Egg",
  "item.minecraft.snowball": "Snowball",
  "item.minecraft.spectral_arrow": "Ghostly Arrow",
  "item.minecraft.spider_eye": "Spider Eye",
  "item.minecraft.spider_spawn_egg": "Spider Making Egg",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Steeple Borrow Trim",
  "item.minecraft.splash_potion": "Splash Lib",
  "item.minecraft.splash_potion.effect.awkward": "Awkward Splash Lib",
  "item.minecraft.splash_potion.effect.empty": "Splash Uncraftbere Lib",
  "item.minecraft.splash_potion.effect.fire_resistance": "Splash Lib of Fire Withstanding",
  "item.minecraft.splash_potion.effect.harming": "Splash Lib of Harming",
  "item.minecraft.splash_potion.effect.healing": "Splash Lib of Healing",
  "item.minecraft.splash_potion.effect.infested": "Splash Lib of Beriding",
  "item.minecraft.splash_potion.effect.invisibility": "Splash Lib of Unseenliness",
  "item.minecraft.splash_potion.effect.leaping": "Splash Lib of Leaping",
  "item.minecraft.splash_potion.effect.levitation": "Splash Lib of Hovering",
  "item.minecraft.splash_potion.effect.luck": "Splash Lib of Luck",
  "item.minecraft.splash_potion.effect.mundane": "Dull Splash Lib",
  "item.minecraft.splash_potion.effect.night_vision": "Splash Lib of Nightsight",
  "item.minecraft.splash_potion.effect.oozing": "Splash Lib of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Splash Lib of Atter",
  "item.minecraft.splash_potion.effect.regeneration": "Splash Lib of Edhealing",
  "item.minecraft.splash_potion.effect.slow_falling": "Splash Lib of Slow Falling",
  "item.minecraft.splash_potion.effect.slowness": "Splash Lib of Slowness",
  "item.minecraft.splash_potion.effect.strength": "Splash Lib of Strength",
  "item.minecraft.splash_potion.effect.swiftness": "Splash Lib of Swiftness",
  "item.minecraft.splash_potion.effect.thick": "Thick Splash Lib",
  "item.minecraft.splash_potion.effect.turtle_master": "Splash Lib of the Birdling Lord",
  "item.minecraft.splash_potion.effect.water": "Splash Water Flash",
  "item.minecraft.splash_potion.effect.water_breathing": "Splash Lib of Water Breathing",
  "item.minecraft.splash_potion.effect.weakness": "Splash Lib of Weakness",
  "item.minecraft.splash_potion.effect.weaving": "Splash Lib of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Lib of Wind Loading",
  "item.minecraft.spruce_boat": "Furrow Boat",
  "item.minecraft.spruce_chest_boat": "Furrow Boat with Chest",
  "item.minecraft.spyglass": "Spirglass",
  "item.minecraft.squid_spawn_egg": "Sleevefish Making Egg",
  "item.minecraft.stick": "Stick",
  "item.minecraft.stone_axe": "Stone Axe",
  "item.minecraft.stone_hoe": "Stone Tiller",
  "item.minecraft.stone_pickaxe": "Stone Mattock",
  "item.minecraft.stone_shovel": "Stone Shovel",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Stone Sword",
  "item.minecraft.stray_spawn_egg": "Drifter Making Egg",
  "item.minecraft.strider_spawn_egg": "Strider Making Egg",
  "item.minecraft.string": "String",
  "item.minecraft.sugar": "Shortsweetening",
  "item.minecraft.suspicious_stew": "Weird Broth",
  "item.minecraft.sweet_berries": "Sweet Berries",
  "item.minecraft.tadpole_bucket": "Stop of Toadhead",
  "item.minecraft.tadpole_spawn_egg": "Toadhead Making Egg",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Borrow Trim",
  "item.minecraft.tipped_arrow": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.awkward": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.empty": "Uncraftbere Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Arrow of Fire Withstanding",
  "item.minecraft.tipped_arrow.effect.harming": "Arrow of Harming",
  "item.minecraft.tipped_arrow.effect.healing": "Arrow of Healing",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Beriding",
  "item.minecraft.tipped_arrow.effect.invisibility": "Arrow of Unseenliness",
  "item.minecraft.tipped_arrow.effect.leaping": "Arrow of Leaping",
  "item.minecraft.tipped_arrow.effect.levitation": "Arrow of Hovering",
  "item.minecraft.tipped_arrow.effect.luck": "Arrow of Luck",
  "item.minecraft.tipped_arrow.effect.mundane": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.night_vision": "Arrow of Nightsight",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Arrow of Atter",
  "item.minecraft.tipped_arrow.effect.regeneration": "Arrow of Edhealing",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Arrow of Slow Falling",
  "item.minecraft.tipped_arrow.effect.slowness": "Arrow of Slowness",
  "item.minecraft.tipped_arrow.effect.strength": "Arrow of Strength",
  "item.minecraft.tipped_arrow.effect.swiftness": "Arrow of Swiftness",
  "item.minecraft.tipped_arrow.effect.thick": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Arrow of the Birdling Lord",
  "item.minecraft.tipped_arrow.effect.water": "Arrow of Splashing",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Arrow of Water Breathing",
  "item.minecraft.tipped_arrow.effect.weakness": "Arrow of Weakness",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Loading",
  "item.minecraft.tnt_minecart": "Delvewain with Blastle",
  "item.minecraft.torchflower_seeds": "Brandblossom Seeds",
  "item.minecraft.totem_of_undying": "Token of Undying",
  "item.minecraft.trader_llama_spawn_egg": "Trader Sheepolvend Making Egg",
  "item.minecraft.trial_key": "Fand Key",
  "item.minecraft.trident": "Leister",
  "item.minecraft.tropical_fish": "Southsea Fish",
  "item.minecraft.tropical_fish_bucket": "Stop of Southsea Fish",
  "item.minecraft.tropical_fish_spawn_egg": "Southsea Fish Making Egg",
  "item.minecraft.turtle_helmet": "Birdling Shell",
  "item.minecraft.turtle_scute": "Birdling Shale",
  "item.minecraft.turtle_spawn_egg": "Birdling Making Egg",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Nettle Borrow Trim",
  "item.minecraft.vex_spawn_egg": "Nettler Making Egg",
  "item.minecraft.villager_spawn_egg": "Thorpsman Making Egg",
  "item.minecraft.vindicator_spawn_egg": "Whitewasher Making Egg",
  "item.minecraft.wandering_trader_spawn_egg": "Wandering Trader Making Egg",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Borrow Trim",
  "item.minecraft.warden_spawn_egg": "Ward Making Egg",
  "item.minecraft.warped_fungus_on_a_stick": "Warped Swamb on a Stick",
  "item.minecraft.water_bucket": "Water Stop",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Borrow Trim",
  "item.minecraft.wheat": "Wheat",
  "item.minecraft.wheat_seeds": "Wheat Seeds",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "White Dye",
  "item.minecraft.white_harness": "White Read",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Forebisen",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Borrow Trim",
  "item.minecraft.wind_charge": "Wind Blast",
  "item.minecraft.witch_spawn_egg": "Witch Making Egg",
  "item.minecraft.wither_skeleton_spawn_egg": "Wither Boneframe Making Egg",
  "item.minecraft.wither_spawn_egg": "Wither Making Egg",
  "item.minecraft.wolf_armor": "Wolf Borrow",
  "item.minecraft.wolf_spawn_egg": "Wolf Making Egg",
  "item.minecraft.wooden_axe": "Wooden Axe",
  "item.minecraft.wooden_hoe": "Wooden Tiller",
  "item.minecraft.wooden_pickaxe": "Wooden Mattock",
  "item.minecraft.wooden_shovel": "Wood Shovel",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Wood Sword",
  "item.minecraft.writable_book": "Book and Quill",
  "item.minecraft.written_book": "Written Book",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Yellow Dye",
  "item.minecraft.yellow_harness": "Yellow Read",
  "item.minecraft.zoglin_spawn_egg": "Zoglin Making Egg",
  "item.minecraft.zombie_horse_spawn_egg": "Lich Horse Making Egg",
  "item.minecraft.zombie_nautilus_spawn_egg": "Lich Shipperfish Making Egg",
  "item.minecraft.zombie_spawn_egg": "Lich Making Egg",
  "item.minecraft.zombie_villager_spawn_egg": "Lich Thorpsman Making Egg",
  "item.minecraft.zombified_piglin_spawn_egg": "Lich Piglin Making Egg"
}
export const enp = items; 
